const counties = [
  // Alabama (01)
  {name: 'Autauga County', fips: '01001'},
  {name: 'Baldwin County', fips: '01003'},
  {name: 'Barbour County', fips: '01005'},
  {name: 'Bibb County', fips: '01007'},
  {name: 'Blount County', fips: '01009'},
  {name: 'Bullock County', fips: '01011'},
  {name: 'Butler County', fips: '01013'},
  {name: 'Calhoun County', fips: '01015'},
  {name: 'Chambers County', fips: '01017'},
  {name: 'Cherokee County', fips: '01019'},
  {name: 'Chilton County', fips: '01021'},
  {name: 'Choctaw County', fips: '01023'},
  {name: 'Clarke County', fips: '01025'},
  {name: 'Clay County', fips: '01027'},
  {name: 'Cleburne County', fips: '01029'},
  {name: 'Coffee County', fips: '01031'},
  {name: 'Colbert County', fips: '01033'},
  {name: 'Conecuh County', fips: '01035'},
  {name: 'Coosa County', fips: '01037'},
  {name: 'Covington County', fips: '01039'},
  {name: 'Crenshaw County', fips: '01041'},
  {name: 'Cullman County', fips: '01043'},
  {name: 'Dale County', fips: '01045'},
  {name: 'Dallas County', fips: '01047'},
  {name: 'DeKalb County', fips: '01049'},
  {name: 'Elmore County', fips: '01051'},
  {name: 'Escambia County', fips: '01053'},
  {name: 'Etowah County', fips: '01055'},
  {name: 'Fayette County', fips: '01057'},
  {name: 'Franklin County', fips: '01059'},
  {name: 'Geneva County', fips: '01061'},
  {name: 'Greene County', fips: '01063'},
  {name: 'Hale County', fips: '01065'},
  {name: 'Henry County', fips: '01067'},
  {name: 'Houston County', fips: '01069'},
  {name: 'Jackson County', fips: '01071'},
  {name: 'Jefferson County', fips: '01073'},
  {name: 'Lamar County', fips: '01075'},
  {name: 'Lauderdale County', fips: '01077'},
  {name: 'Lawrence County', fips: '01079'},
  {name: 'Lee County', fips: '01081'},
  {name: 'Limestone County', fips: '01083'},
  {name: 'Lowndes County', fips: '01085'},
  {name: 'Macon County', fips: '01087'},
  {name: 'Madison County', fips: '01089'},
  {name: 'Marengo County', fips: '01091'},
  {name: 'Marion County', fips: '01093'},
  {name: 'Marshall County', fips: '01095'},
  {name: 'Mobile County', fips: '01097'},
  {name: 'Monroe County', fips: '01099'},
  {name: 'Montgomery County', fips: '01101'},
  {name: 'Morgan County', fips: '01103'},
  {name: 'Perry County', fips: '01105'},
  {name: 'Pickens County', fips: '01107'},
  {name: 'Pike County', fips: '01109'},
  {name: 'Randolph County', fips: '01111'},
  {name: 'Russell County', fips: '01113'},
  {name: 'St. Clair County', fips: '01115'},
  {name: 'Shelby County', fips: '01117'},
  {name: 'Sumter County', fips: '01119'},
  {name: 'Talladega County', fips: '01121'},
  {name: 'Tallapoosa County', fips: '01123'},
  {name: 'Tuscaloosa County', fips: '01125'},
  {name: 'Walker County', fips: '01127'},
  {name: 'Washington County', fips: '01129'},
  {name: 'Wilcox County', fips: '01131'},
  {name: 'Winston County', fips: '01133'},

  // Alaska (02)
  {name: 'Aleutians East Borough', fips: '02013'},
  {name: 'Aleutians West Census Area', fips: '02016'},
  {name: 'Anchorage Municipality', fips: '02020'},
  {name: 'Bethel Census Area', fips: '02050'},
  {name: 'Bristol Bay Borough', fips: '02060'},
  {name: 'Denali Borough', fips: '02068'},
  {name: 'Dillingham Census Area', fips: '02070'},
  {name: 'Fairbanks North Star Borough', fips: '02090'},
  {name: 'Haines Borough', fips: '02100'},
  {name: 'Hoonah-Angoon Census Area', fips: '02105'},
  {name: 'Juneau City and Borough', fips: '02110'},
  {name: 'Kenai Peninsula Borough', fips: '02122'},
  {name: 'Ketchikan Gateway Borough', fips: '02130'},
  {name: 'Kodiak Island Borough', fips: '02150'},
  {name: 'Kusilvak Census Area', fips: '02158'},
  {name: 'Lake and Peninsula Borough', fips: '02164'},
  {name: 'Matanuska-Susitna Borough', fips: '02170'},
  {name: 'Nome Census Area', fips: '02180'},
  {name: 'North Slope Borough', fips: '02185'},
  {name: 'Northwest Arctic Borough', fips: '02188'},
  {name: 'Petersburg Borough', fips: '02195'},
  {name: 'Prince of Wales-Hyder Census Area', fips: '02198'},
  {name: 'Sitka City and Borough', fips: '02220'},
  {name: 'Skagway Municipality', fips: '02230'},
  {name: 'Southeast Fairbanks Census Area', fips: '02240'},
  {name: 'Valdez-Cordova Census Area', fips: '02261'},
  {name: 'Wrangell City and Borough', fips: '02275'},
  {name: 'Yakutat City and Borough', fips: '02282'},
  {name: 'Yukon-Koyukuk Census Area', fips: '02290'},

  // Arizona (04)
  {name: 'Apache County', fips: '04001'},
  {name: 'Cochise County', fips: '04003'},
  {name: 'Coconino County', fips: '04005'},
  {name: 'Gila County', fips: '04007'},
  {name: 'Graham County', fips: '04009'},
  {name: 'Greenlee County', fips: '04011'},
  {name: 'La Paz County', fips: '04012'},
  {name: 'Maricopa County', fips: '04013'},
  {name: 'Mohave County', fips: '04015'},
  {name: 'Navajo County', fips: '04017'},
  {name: 'Pima County', fips: '04019'},
  {name: 'Pinal County', fips: '04021'},
  {name: 'Santa Cruz County', fips: '04023'},
  {name: 'Yavapai County', fips: '04025'},
  {name: 'Yuma County', fips: '04027'},

  // Arkansas (05)
  {name: 'Arkansas County', fips: '05001'},
  {name: 'Ashley County', fips: '05003'},
  {name: 'Baxter County', fips: '05005'},
  {name: 'Benton County', fips: '05007'},
  {name: 'Boone County', fips: '05009'},
  {name: 'Bradley County', fips: '05011'},
  {name: 'Calhoun County', fips: '05013'},
  {name: 'Carroll County', fips: '05015'},
  {name: 'Chicot County', fips: '05017'},
  {name: 'Clark County', fips: '05019'},
  {name: 'Clay County', fips: '05021'},
  {name: 'Cleburne County', fips: '05023'},
  {name: 'Cleveland County', fips: '05025'},
  {name: 'Columbia County', fips: '05027'},
  {name: 'Conway County', fips: '05029'},
  {name: 'Craighead County', fips: '05031'},
  {name: 'Crawford County', fips: '05033'},
  {name: 'Crittenden County', fips: '05035'},
  {name: 'Cross County', fips: '05037'},
  {name: 'Dallas County', fips: '05039'},
  {name: 'Desha County', fips: '05041'},
  {name: 'Drew County', fips: '05043'},
  {name: 'Faulkner County', fips: '05045'},
  {name: 'Franklin County', fips: '05047'},
  {name: 'Fulton County', fips: '05049'},
  {name: 'Garland County', fips: '05051'},
  {name: 'Grant County', fips: '05053'},
  {name: 'Greene County', fips: '05055'},
  {name: 'Hempstead County', fips: '05057'},
  {name: 'Hot Spring County', fips: '05059'},
  {name: 'Howard County', fips: '05061'},
  {name: 'Independence County', fips: '05063'},
  {name: 'Izard County', fips: '05065'},
  {name: 'Jackson County', fips: '05067'},
  {name: 'Jefferson County', fips: '05069'},
  {name: 'Johnson County', fips: '05071'},
  {name: 'Lafayette County', fips: '05073'},
  {name: 'Lawrence County', fips: '05075'},
  {name: 'Lee County', fips: '05077'},
  {name: 'Lincoln County', fips: '05079'},
  {name: 'Little River County', fips: '05081'},
  {name: 'Logan County', fips: '05083'},
  {name: 'Lonoke County', fips: '05085'},
  {name: 'Madison County', fips: '05087'},
  {name: 'Marion County', fips: '05089'},
  {name: 'Miller County', fips: '05091'},
  {name: 'Mississippi County', fips: '05093'},
  {name: 'Monroe County', fips: '05095'},
  {name: 'Montgomery County', fips: '05097'},
  {name: 'Nevada County', fips: '05099'},
  {name: 'Newton County', fips: '05101'},
  {name: 'Ouachita County', fips: '05103'},
  {name: 'Perry County', fips: '05105'},
  {name: 'Phillips County', fips: '05107'},
  {name: 'Pike County', fips: '05109'},
  {name: 'Poinsett County', fips: '05111'},
  {name: 'Polk County', fips: '05113'},
  {name: 'Pope County', fips: '05115'},
  {name: 'Prairie County', fips: '05117'},
  {name: 'Pulaski County', fips: '05119'},
  {name: 'Randolph County', fips: '05121'},
  {name: 'St. Francis County', fips: '05123'},
  {name: 'Saline County', fips: '05125'},
  {name: 'Scott County', fips: '05127'},
  {name: 'Searcy County', fips: '05129'},
  {name: 'Sebastian County', fips: '05131'},
  {name: 'Sevier County', fips: '05133'},
  {name: 'Sharp County', fips: '05135'},
  {name: 'Stone County', fips: '05137'},
  {name: 'Union County', fips: '05139'},
  {name: 'Van Buren County', fips: '05141'},
  {name: 'Washington County', fips: '05143'},
  {name: 'White County', fips: '05145'},
  {name: 'Woodruff County', fips: '05147'},
  {name: 'Yell County', fips: '05149'},

  // California (06)
  {name: 'Alameda County', fips: '06001'},
  {name: 'Alpine County', fips: '06003'},
  {name: 'Amador County', fips: '06005'},
  {name: 'Butte County', fips: '06007'},
  {name: 'Calaveras County', fips: '06009'},
  {name: 'Colusa County', fips: '06011'},
  {name: 'Contra Costa County', fips: '06013'},
  {name: 'Del Norte County', fips: '06015'},
  {name: 'El Dorado County', fips: '06017'},
  {name: 'Fresno County', fips: '06019'},
  {name: 'Glenn County', fips: '06021'},
  {name: 'Humboldt County', fips: '06023'},
  {name: 'Imperial County', fips: '06025'},
  {name: 'Inyo County', fips: '06027'},
  {name: 'Kern County', fips: '06029'},
  {name: 'Kings County', fips: '06031'},
  {name: 'Lake County', fips: '06033'},
  {name: 'Lassen County', fips: '06035'},
  {name: 'Los Angeles County', fips: '06037'},
  {name: 'Madera County', fips: '06039'},
  {name: 'Marin County', fips: '06041'},
  {name: 'Mariposa County', fips: '06043'},
  {name: 'Mendocino County', fips: '06045'},
  {name: 'Merced County', fips: '06047'},
  {name: 'Modoc County', fips: '06049'},
  {name: 'Mono County', fips: '06051'},
  {name: 'Monterey County', fips: '06053'},
  {name: 'Napa County', fips: '06055'},
  {name: 'Nevada County', fips: '06057'},
  {name: 'Orange County', fips: '06059'},
  {name: 'Placer County', fips: '06061'},
  {name: 'Plumas County', fips: '06063'},
  {name: 'Riverside County', fips: '06065'},
  {name: 'Sacramento County', fips: '06067'},
  {name: 'San Benito County', fips: '06069'},
  {name: 'San Bernardino County', fips: '06071'},
  {name: 'San Diego County', fips: '06073'},
  {name: 'San Francisco County', fips: '06075'},
  {name: 'San Joaquin County', fips: '06077'},
  {name: 'San Luis Obispo County', fips: '06079'},
  {name: 'San Mateo County', fips: '06081'},
  {name: 'Santa Barbara County', fips: '06083'},
  {name: 'Santa Clara County', fips: '06085'},
  {name: 'Santa Cruz County', fips: '06087'},
  {name: 'Shasta County', fips: '06089'},
  {name: 'Sierra County', fips: '06091'},
  {name: 'Siskiyou County', fips: '06093'},
  {name: 'Solano County', fips: '06095'},
  {name: 'Sonoma County', fips: '06097'},
  {name: 'Stanislaus County', fips: '06099'},
  {name: 'Sutter County', fips: '06101'},
  {name: 'Tehama County', fips: '06103'},
  {name: 'Trinity County', fips: '06105'},
  {name: 'Tulare County', fips: '06107'},
  {name: 'Tuolumne County', fips: '06109'},
  {name: 'Ventura County', fips: '06111'},
  {name: 'Yolo County', fips: '06113'},
  {name: 'Yuba County', fips: '06115'},

  // Colorado (08)
  {name: 'Adams County', fips: '08001'},
  {name: 'Alamosa County', fips: '08003'},
  {name: 'Arapahoe County', fips: '08005'},
  {name: 'Archuleta County', fips: '08007'},
  {name: 'Baca County', fips: '08009'},
  {name: 'Bent County', fips: '08011'},
  {name: 'Boulder County', fips: '08013'},
  {name: 'Broomfield County', fips: '08014'},
  {name: 'Chaffee County', fips: '08015'},
  {name: 'Cheyenne County', fips: '08017'},
  {name: 'Clear Creek County', fips: '08019'},
  {name: 'Conejos County', fips: '08021'},
  {name: 'Costilla County', fips: '08023'},
  {name: 'Crowley County', fips: '08025'},
  {name: 'Custer County', fips: '08027'},
  {name: 'Delta County', fips: '08029'},
  {name: 'Denver County', fips: '08031'},
  {name: 'Dolores County', fips: '08033'},
  {name: 'Douglas County', fips: '08035'},
  {name: 'Eagle County', fips: '08037'},
  {name: 'Elbert County', fips: '08039'},
  {name: 'El Paso County', fips: '08041'},
  {name: 'Fremont County', fips: '08043'},
  {name: 'Garfield County', fips: '08045'},
  {name: 'Gilpin County', fips: '08047'},
  {name: 'Grand County', fips: '08049'},
  {name: 'Gunnison County', fips: '08051'},
  {name: 'Hinsdale County', fips: '08053'},
  {name: 'Huerfano County', fips: '08055'},
  {name: 'Jackson County', fips: '08057'},
  {name: 'Jefferson County', fips: '08059'},
  {name: 'Kiowa County', fips: '08061'},
  {name: 'Kit Carson County', fips: '08063'},
  {name: 'Lake County', fips: '08065'},
  {name: 'La Plata County', fips: '08067'},
  {name: 'Larimer County', fips: '08069'},
  {name: 'Las Animas County', fips: '08071'},
  {name: 'Lincoln County', fips: '08073'},
  {name: 'Logan County', fips: '08075'},
  {name: 'Mesa County', fips: '08077'},
  {name: 'Mineral County', fips: '08079'},
  {name: 'Moffat County', fips: '08081'},
  {name: 'Montezuma County', fips: '08083'},
  {name: 'Montrose County', fips: '08085'},
  {name: 'Morgan County', fips: '08087'},
  {name: 'Otero County', fips: '08089'},
  {name: 'Ouray County', fips: '08091'},
  {name: 'Park County', fips: '08093'},
  {name: 'Phillips County', fips: '08095'},
  {name: 'Pitkin County', fips: '08097'},
  {name: 'Prowers County', fips: '08099'},
  {name: 'Pueblo County', fips: '08101'},
  {name: 'Rio Blanco County', fips: '08103'},
  {name: 'Rio Grande County', fips: '08105'},
  {name: 'Routt County', fips: '08107'},
  {name: 'Saguache County', fips: '08109'},
  {name: 'San Juan County', fips: '08111'},
  {name: 'San Miguel County', fips: '08113'},
  {name: 'Sedgwick County', fips: '08115'},
  {name: 'Summit County', fips: '08117'},
  {name: 'Teller County', fips: '08119'},
  {name: 'Washington County', fips: '08121'},
  {name: 'Weld County', fips: '08123'},
  {name: 'Yuma County', fips: '08125'},

  // Connecticut (09)
  {name: 'Fairfield County', fips: '09001'},
  {name: 'Hartford County', fips: '09003'},
  {name: 'Litchfield County', fips: '09005'},
  {name: 'Middlesex County', fips: '09007'},
  {name: 'New Haven County', fips: '09009'},
  {name: 'New London County', fips: '09011'},
  {name: 'Tolland County', fips: '09013'},
  {name: 'Windham County', fips: '09015'},

  // Delaware (10)
  {name: 'Kent County', fips: '10001'},
  {name: 'New Castle County', fips: '10003'},
  {name: 'Sussex County', fips: '10005'},

  // District of Columbia (11)
  {name: 'District of Columbia', fips: '11001'},

  // Florida (12)
  {name: 'Alachua County', fips: '12001'},
  {name: 'Baker County', fips: '12003'},
  {name: 'Bay County', fips: '12005'},
  {name: 'Bradford County', fips: '12007'},
  {name: 'Brevard County', fips: '12009'},
  {name: 'Broward County', fips: '12011'},
  {name: 'Calhoun County', fips: '12013'},
  {name: 'Charlotte County', fips: '12015'},
  {name: 'Citrus County', fips: '12017'},
  {name: 'Clay County', fips: '12019'},
  {name: 'Collier County', fips: '12021'},
  {name: 'Columbia County', fips: '12023'},
  {name: 'DeSoto County', fips: '12027'},
  {name: 'Dixie County', fips: '12029'},
  {name: 'Duval County', fips: '12031'},
  {name: 'Escambia County', fips: '12033'},
  {name: 'Flagler County', fips: '12035'},
  {name: 'Franklin County', fips: '12037'},
  {name: 'Gadsden County', fips: '12039'},
  {name: 'Gilchrist County', fips: '12041'},
  {name: 'Glades County', fips: '12043'},
  {name: 'Gulf County', fips: '12045'},
  {name: 'Hamilton County', fips: '12047'},
  {name: 'Hardee County', fips: '12049'},
  {name: 'Hendry County', fips: '12051'},
  {name: 'Hernando County', fips: '12053'},
  {name: 'Highlands County', fips: '12055'},
  {name: 'Hillsborough County', fips: '12057'},
  {name: 'Holmes County', fips: '12059'},
  {name: 'Indian River County', fips: '12061'},
  {name: 'Jackson County', fips: '12063'},
  {name: 'Jefferson County', fips: '12065'},
  {name: 'Lafayette County', fips: '12067'},
  {name: 'Lake County', fips: '12069'},
  {name: 'Lee County', fips: '12071'},
  {name: 'Leon County', fips: '12073'},
  {name: 'Levy County', fips: '12075'},
  {name: 'Liberty County', fips: '12077'},
  {name: 'Madison County', fips: '12079'},
  {name: 'Manatee County', fips: '12081'},
  {name: 'Marion County', fips: '12083'},
  {name: 'Martin County', fips: '12085'},
  {name: 'Miami-Dade County', fips: '12086'},
  {name: 'Monroe County', fips: '12087'},
  {name: 'Nassau County', fips: '12089'},
  {name: 'Okaloosa County', fips: '12091'},
  {name: 'Okeechobee County', fips: '12093'},
  {name: 'Orange County', fips: '12095'},
  {name: 'Osceola County', fips: '12097'},
  {name: 'Palm Beach County', fips: '12099'},
  {name: 'Pasco County', fips: '12101'},
  {name: 'Pinellas County', fips: '12103'},
  {name: 'Polk County', fips: '12105'},
  {name: 'Putnam County', fips: '12107'},
  {name: 'St. Johns County', fips: '12109'},
  {name: 'St. Lucie County', fips: '12111'},
  {name: 'Santa Rosa County', fips: '12113'},
  {name: 'Sarasota County', fips: '12115'},
  {name: 'Seminole County', fips: '12117'},
  {name: 'Sumter County', fips: '12119'},
  {name: 'Suwannee County', fips: '12121'},
  {name: 'Taylor County', fips: '12123'},
  {name: 'Union County', fips: '12125'},
  {name: 'Volusia County', fips: '12127'},
  {name: 'Wakulla County', fips: '12129'},
  {name: 'Walton County', fips: '12131'},
  {name: 'Washington County', fips: '12133'},

  // Georgia (13)
  {name: 'Appling County', fips: '13001'},
  {name: 'Atkinson County', fips: '13003'},
  {name: 'Bacon County', fips: '13005'},
  {name: 'Baker County', fips: '13007'},
  {name: 'Baldwin County', fips: '13009'},
  {name: 'Banks County', fips: '13011'},
  {name: 'Barrow County', fips: '13013'},
  {name: 'Bartow County', fips: '13015'},
  {name: 'Ben Hill County', fips: '13017'},
  {name: 'Berrien County', fips: '13019'},
  {name: 'Bibb County', fips: '13021'},
  {name: 'Bleckley County', fips: '13023'},
  {name: 'Brantley County', fips: '13025'},
  {name: 'Brooks County', fips: '13027'},
  {name: 'Bryan County', fips: '13029'},
  {name: 'Bulloch County', fips: '13031'},
  {name: 'Burke County', fips: '13033'},
  {name: 'Butts County', fips: '13035'},
  {name: 'Calhoun County', fips: '13037'},
  {name: 'Camden County', fips: '13039'},
  {name: 'Candler County', fips: '13043'},
  {name: 'Carroll County', fips: '13045'},
  {name: 'Catoosa County', fips: '13047'},
  {name: 'Charlton County', fips: '13049'},
  {name: 'Chatham County', fips: '13051'},
  {name: 'Chattahoochee County', fips: '13053'},
  {name: 'Chattooga County', fips: '13055'},
  {name: 'Cherokee County', fips: '13057'},
  {name: 'Clarke County', fips: '13059'},
  {name: 'Clay County', fips: '13061'},
  {name: 'Clayton County', fips: '13063'},
  {name: 'Clinch County', fips: '13065'},
  {name: 'Cobb County', fips: '13067'},
  {name: 'Coffee County', fips: '13069'},
  {name: 'Colquitt County', fips: '13071'},
  {name: 'Columbia County', fips: '13073'},
  {name: 'Cook County', fips: '13075'},
  {name: 'Coweta County', fips: '13077'},
  {name: 'Crawford County', fips: '13079'},
  {name: 'Crisp County', fips: '13081'},
  {name: 'Dade County', fips: '13083'},
  {name: 'Dawson County', fips: '13085'},
  {name: 'Decatur County', fips: '13087'},
  {name: 'DeKalb County', fips: '13089'},
  {name: 'Dodge County', fips: '13091'},
  {name: 'Dooly County', fips: '13093'},
  {name: 'Dougherty County', fips: '13095'},
  {name: 'Douglas County', fips: '13097'},
  {name: 'Early County', fips: '13099'},
  {name: 'Echols County', fips: '13101'},
  {name: 'Effingham County', fips: '13103'},
  {name: 'Elbert County', fips: '13105'},
  {name: 'Emanuel County', fips: '13107'},
  {name: 'Evans County', fips: '13109'},
  {name: 'Fannin County', fips: '13111'},
  {name: 'Fayette County', fips: '13113'},
  {name: 'Floyd County', fips: '13115'},
  {name: 'Forsyth County', fips: '13117'},
  {name: 'Franklin County', fips: '13119'},
  {name: 'Fulton County', fips: '13121'},
  {name: 'Gilmer County', fips: '13123'},
  {name: 'Glascock County', fips: '13125'},
  {name: 'Glynn County', fips: '13127'},
  {name: 'Gordon County', fips: '13129'},
  {name: 'Grady County', fips: '13131'},
  {name: 'Greene County', fips: '13133'},
  {name: 'Gwinnett County', fips: '13135'},
  {name: 'Habersham County', fips: '13137'},
  {name: 'Hall County', fips: '13139'},
  {name: 'Hancock County', fips: '13141'},
  {name: 'Haralson County', fips: '13143'},
  {name: 'Harris County', fips: '13145'},
  {name: 'Hart County', fips: '13147'},
  {name: 'Heard County', fips: '13149'},
  {name: 'Henry County', fips: '13151'},
  {name: 'Houston County', fips: '13153'},
  {name: 'Irwin County', fips: '13155'},
  {name: 'Jackson County', fips: '13157'},
  {name: 'Jasper County', fips: '13159'},
  {name: 'Jeff Davis County', fips: '13161'},
  {name: 'Jefferson County', fips: '13163'},
  {name: 'Jenkins County', fips: '13165'},
  {name: 'Johnson County', fips: '13167'},
  {name: 'Jones County', fips: '13169'},
  {name: 'Lamar County', fips: '13171'},
  {name: 'Lanier County', fips: '13173'},
  {name: 'Laurens County', fips: '13175'},
  {name: 'Lee County', fips: '13177'},
  {name: 'Liberty County', fips: '13179'},
  {name: 'Lincoln County', fips: '13181'},
  {name: 'Long County', fips: '13183'},
  {name: 'Lowndes County', fips: '13185'},
  {name: 'Lumpkin County', fips: '13187'},
  {name: 'McDuffie County', fips: '13189'},
  {name: 'McIntosh County', fips: '13191'},
  {name: 'Macon County', fips: '13193'},
  {name: 'Madison County', fips: '13195'},
  {name: 'Marion County', fips: '13197'},
  {name: 'Meriwether County', fips: '13199'},
  {name: 'Miller County', fips: '13201'},
  {name: 'Mitchell County', fips: '13205'},
  {name: 'Monroe County', fips: '13207'},
  {name: 'Montgomery County', fips: '13209'},
  {name: 'Morgan County', fips: '13211'},
  {name: 'Murray County', fips: '13213'},
  {name: 'Muscogee County', fips: '13215'},
  {name: 'Newton County', fips: '13217'},
  {name: 'Oconee County', fips: '13219'},
  {name: 'Oglethorpe County', fips: '13221'},
  {name: 'Paulding County', fips: '13223'},
  {name: 'Peach County', fips: '13225'},
  {name: 'Pickens County', fips: '13227'},
  {name: 'Pierce County', fips: '13229'},
  {name: 'Pike County', fips: '13231'},
  {name: 'Polk County', fips: '13233'},
  {name: 'Pulaski County', fips: '13235'},
  {name: 'Putnam County', fips: '13237'},
  {name: 'Quitman County', fips: '13239'},
  {name: 'Rabun County', fips: '13241'},
  {name: 'Randolph County', fips: '13243'},
  {name: 'Richmond County', fips: '13245'},
  {name: 'Rockdale County', fips: '13247'},
  {name: 'Schley County', fips: '13249'},
  {name: 'Screven County', fips: '13251'},
  {name: 'Seminole County', fips: '13253'},
  {name: 'Spalding County', fips: '13255'},
  {name: 'Stephens County', fips: '13257'},
  {name: 'Stewart County', fips: '13259'},
  {name: 'Sumter County', fips: '13261'},
  {name: 'Talbot County', fips: '13263'},
  {name: 'Taliaferro County', fips: '13265'},
  {name: 'Tattnall County', fips: '13267'},
  {name: 'Taylor County', fips: '13269'},
  {name: 'Telfair County', fips: '13271'},
  {name: 'Terrell County', fips: '13273'},
  {name: 'Thomas County', fips: '13275'},
  {name: 'Tift County', fips: '13277'},
  {name: 'Toombs County', fips: '13279'},
  {name: 'Towns County', fips: '13281'},
  {name: 'Treutlen County', fips: '13283'},
  {name: 'Troup County', fips: '13285'},
  {name: 'Turner County', fips: '13287'},
  {name: 'Twiggs County', fips: '13289'},
  {name: 'Union County', fips: '13291'},
  {name: 'Upson County', fips: '13293'},
  {name: 'Walker County', fips: '13295'},
  {name: 'Walton County', fips: '13297'},
  {name: 'Ware County', fips: '13299'},
  {name: 'Warren County', fips: '13301'},
  {name: 'Washington County', fips: '13303'},
  {name: 'Wayne County', fips: '13305'},
  {name: 'Webster County', fips: '13307'},
  {name: 'Wheeler County', fips: '13309'},
  {name: 'White County', fips: '13311'},
  {name: 'Whitfield County', fips: '13313'},
  {name: 'Wilcox County', fips: '13315'},
  {name: 'Wilkes County', fips: '13317'},
  {name: 'Wilkinson County', fips: '13319'},
  {name: 'Worth County', fips: '13321'},

  // Hawaii (15)
  {name: 'Hawaii County', fips: '15001'},
  {name: 'Honolulu County', fips: '15003'},
  {name: 'Kalawao County', fips: '15005'},
  {name: 'Kauai County', fips: '15007'},
  {name: 'Maui County', fips: '15009'},

  // Idaho (16)
  {name: 'Ada County', fips: '16001'},
  {name: 'Adams County', fips: '16003'},
  {name: 'Bannock County', fips: '16005'},
  {name: 'Bear Lake County', fips: '16007'},
  {name: 'Benewah County', fips: '16009'},
  {name: 'Bingham County', fips: '16011'},
  {name: 'Blaine County', fips: '16013'},
  {name: 'Boise County', fips: '16015'},
  {name: 'Bonner County', fips: '16017'},
  {name: 'Bonneville County', fips: '16019'},
  {name: 'Boundary County', fips: '16021'},
  {name: 'Butte County', fips: '16023'},
  {name: 'Camas County', fips: '16025'},
  {name: 'Canyon County', fips: '16027'},
  {name: 'Caribou County', fips: '16029'},
  {name: 'Cassia County', fips: '16031'},
  {name: 'Clark County', fips: '16033'},
  {name: 'Clearwater County', fips: '16035'},
  {name: 'Custer County', fips: '16037'},
  {name: 'Elmore County', fips: '16039'},
  {name: 'Franklin County', fips: '16041'},
  {name: 'Fremont County', fips: '16043'},
  {name: 'Gem County', fips: '16045'},
  {name: 'Gooding County', fips: '16047'},
  {name: 'Idaho County', fips: '16049'},
  {name: 'Jefferson County', fips: '16051'},
  {name: 'Jerome County', fips: '16053'},
  {name: 'Kootenai County', fips: '16055'},
  {name: 'Latah County', fips: '16057'},
  {name: 'Lemhi County', fips: '16059'},
  {name: 'Lewis County', fips: '16061'},
  {name: 'Lincoln County', fips: '16063'},
  {name: 'Madison County', fips: '16065'},
  {name: 'Minidoka County', fips: '16067'},
  {name: 'Nez Perce County', fips: '16069'},
  {name: 'Oneida County', fips: '16071'},
  {name: 'Owyhee County', fips: '16073'},
  {name: 'Payette County', fips: '16075'},
  {name: 'Power County', fips: '16077'},
  {name: 'Shoshone County', fips: '16079'},
  {name: 'Teton County', fips: '16081'},
  {name: 'Twin Falls County', fips: '16083'},
  {name: 'Valley County', fips: '16085'},
  {name: 'Washington County', fips: '16087'},

  // Illinois (17)
  {name: 'Adams County', fips: '17001'},
  {name: 'Alexander County', fips: '17003'},
  {name: 'Bond County', fips: '17005'},
  {name: 'Boone County', fips: '17007'},
  {name: 'Brown County', fips: '17009'},
  {name: 'Bureau County', fips: '17011'},
  {name: 'Calhoun County', fips: '17013'},
  {name: 'Carroll County', fips: '17015'},
  {name: 'Cass County', fips: '17017'},
  {name: 'Champaign County', fips: '17019'},
  {name: 'Christian County', fips: '17021'},
  {name: 'Clark County', fips: '17023'},
  {name: 'Clay County', fips: '17025'},
  {name: 'Clinton County', fips: '17027'},
  {name: 'Coles County', fips: '17029'},
  {name: 'Cook County', fips: '17031'},
  {name: 'Crawford County', fips: '17033'},
  {name: 'Cumberland County', fips: '17035'},
  {name: 'DeKalb County', fips: '17037'},
  {name: 'De Witt County', fips: '17039'},
  {name: 'Douglas County', fips: '17041'},
  {name: 'DuPage County', fips: '17043'},
  {name: 'Edgar County', fips: '17045'},
  {name: 'Edwards County', fips: '17047'},
  {name: 'Effingham County', fips: '17049'},
  {name: 'Fayette County', fips: '17051'},
  {name: 'Ford County', fips: '17053'},
  {name: 'Franklin County', fips: '17055'},
  {name: 'Fulton County', fips: '17057'},
  {name: 'Gallatin County', fips: '17059'},
  {name: 'Greene County', fips: '17061'},
  {name: 'Grundy County', fips: '17063'},
  {name: 'Hamilton County', fips: '17065'},
  {name: 'Hancock County', fips: '17067'},
  {name: 'Hardin County', fips: '17069'},
  {name: 'Henderson County', fips: '17071'},
  {name: 'Henry County', fips: '17073'},
  {name: 'Iroquois County', fips: '17075'},
  {name: 'Jackson County', fips: '17077'},
  {name: 'Jasper County', fips: '17079'},
  {name: 'Jefferson County', fips: '17081'},
  {name: 'Jersey County', fips: '17083'},
  {name: 'Jo Daviess County', fips: '17085'},
  {name: 'Johnson County', fips: '17087'},
  {name: 'Kane County', fips: '17089'},
  {name: 'Kankakee County', fips: '17091'},
  {name: 'Kendall County', fips: '17093'},
  {name: 'Knox County', fips: '17095'},
  {name: 'Lake County', fips: '17097'},
  {name: 'LaSalle County', fips: '17099'},
  {name: 'Lawrence County', fips: '17101'},
  {name: 'Lee County', fips: '17103'},
  {name: 'Livingston County', fips: '17105'},
  {name: 'Logan County', fips: '17107'},
  {name: 'McDonough County', fips: '17109'},
  {name: 'McHenry County', fips: '17111'},
  {name: 'McLean County', fips: '17113'},
  {name: 'Macon County', fips: '17115'},
  {name: 'Macoupin County', fips: '17117'},
  {name: 'Madison County', fips: '17119'},
  {name: 'Marion County', fips: '17121'},
  {name: 'Marshall County', fips: '17123'},
  {name: 'Mason County', fips: '17125'},
  {name: 'Massac County', fips: '17127'},
  {name: 'Menard County', fips: '17129'},
  {name: 'Mercer County', fips: '17131'},
  {name: 'Monroe County', fips: '17133'},
  {name: 'Montgomery County', fips: '17135'},
  {name: 'Morgan County', fips: '17137'},
  {name: 'Moultrie County', fips: '17139'},
  {name: 'Ogle County', fips: '17141'},
  {name: 'Peoria County', fips: '17143'},
  {name: 'Perry County', fips: '17145'},
  {name: 'Piatt County', fips: '17147'},
  {name: 'Pike County', fips: '17149'},
  {name: 'Pope County', fips: '17151'},
  {name: 'Pulaski County', fips: '17153'},
  {name: 'Putnam County', fips: '17155'},
  {name: 'Randolph County', fips: '17157'},
  {name: 'Richland County', fips: '17159'},
  {name: 'Rock Island County', fips: '17161'},
  {name: 'St. Clair County', fips: '17163'},
  {name: 'Saline County', fips: '17165'},
  {name: 'Sangamon County', fips: '17167'},
  {name: 'Schuyler County', fips: '17169'},
  {name: 'Scott County', fips: '17171'},
  {name: 'Shelby County', fips: '17173'},
  {name: 'Stark County', fips: '17175'},
  {name: 'Stephenson County', fips: '17177'},
  {name: 'Tazewell County', fips: '17179'},
  {name: 'Union County', fips: '17181'},
  {name: 'Vermilion County', fips: '17183'},
  {name: 'Wabash County', fips: '17185'},
  {name: 'Warren County', fips: '17187'},
  {name: 'Washington County', fips: '17189'},
  {name: 'Wayne County', fips: '17191'},
  {name: 'White County', fips: '17193'},
  {name: 'Whiteside County', fips: '17195'},
  {name: 'Will County', fips: '17197'},
  {name: 'Williamson County', fips: '17199'},
  {name: 'Winnebago County', fips: '17201'},
  {name: 'Woodford County', fips: '17203'},

  // Indiana (18)
  {name: 'Adams County', fips: '18001'},
  {name: 'Allen County', fips: '18003'},
  {name: 'Bartholomew County', fips: '18005'},
  {name: 'Benton County', fips: '18007'},
  {name: 'Blackford County', fips: '18009'},
  {name: 'Boone County', fips: '18011'},
  {name: 'Brown County', fips: '18013'},
  {name: 'Carroll County', fips: '18015'},
  {name: 'Cass County', fips: '18017'},
  {name: 'Clark County', fips: '18019'},
  {name: 'Clay County', fips: '18021'},
  {name: 'Clinton County', fips: '18023'},
  {name: 'Crawford County', fips: '18025'},
  {name: 'Daviess County', fips: '18027'},
  {name: 'Dearborn County', fips: '18029'},
  {name: 'Decatur County', fips: '18031'},
  {name: 'DeKalb County', fips: '18033'},
  {name: 'Delaware County', fips: '18035'},
  {name: 'Dubois County', fips: '18037'},
  {name: 'Elkhart County', fips: '18039'},
  {name: 'Fayette County', fips: '18041'},
  {name: 'Floyd County', fips: '18043'},
  {name: 'Fountain County', fips: '18045'},
  {name: 'Franklin County', fips: '18047'},
  {name: 'Fulton County', fips: '18049'},
  {name: 'Gibson County', fips: '18051'},
  {name: 'Grant County', fips: '18053'},
  {name: 'Greene County', fips: '18055'},
  {name: 'Hamilton County', fips: '18057'},
  {name: 'Hancock County', fips: '18059'},
  {name: 'Harrison County', fips: '18061'},
  {name: 'Hendricks County', fips: '18063'},
  {name: 'Henry County', fips: '18065'},
  {name: 'Howard County', fips: '18067'},
  {name: 'Huntington County', fips: '18069'},
  {name: 'Jackson County', fips: '18071'},
  {name: 'Jasper County', fips: '18073'},
  {name: 'Jay County', fips: '18075'},
  {name: 'Jefferson County', fips: '18077'},
  {name: 'Jennings County', fips: '18079'},
  {name: 'Johnson County', fips: '18081'},
  {name: 'Knox County', fips: '18083'},
  {name: 'Kosciusko County', fips: '18085'},
  {name: 'LaGrange County', fips: '18087'},
  {name: 'Lake County', fips: '18089'},
  {name: 'LaPorte County', fips: '18091'},
  {name: 'Lawrence County', fips: '18093'},
  {name: 'Madison County', fips: '18095'},
  {name: 'Marion County', fips: '18097'},
  {name: 'Marshall County', fips: '18099'},
  {name: 'Martin County', fips: '18101'},
  {name: 'Miami County', fips: '18103'},
  {name: 'Monroe County', fips: '18105'},
  {name: 'Montgomery County', fips: '18107'},
  {name: 'Morgan County', fips: '18109'},
  {name: 'Newton County', fips: '18111'},
  {name: 'Noble County', fips: '18113'},
  {name: 'Ohio County', fips: '18115'},
  {name: 'Orange County', fips: '18117'},
  {name: 'Owen County', fips: '18119'},
  {name: 'Parke County', fips: '18121'},
  {name: 'Perry County', fips: '18123'},
  {name: 'Pike County', fips: '18125'},
  {name: 'Porter County', fips: '18127'},
  {name: 'Posey County', fips: '18129'},
  {name: 'Pulaski County', fips: '18131'},
  {name: 'Putnam County', fips: '18133'},
  {name: 'Randolph County', fips: '18135'},
  {name: 'Ripley County', fips: '18137'},
  {name: 'Rush County', fips: '18139'},
  {name: 'St. Joseph County', fips: '18141'},
  {name: 'Scott County', fips: '18143'},
  {name: 'Shelby County', fips: '18145'},
  {name: 'Spencer County', fips: '18147'},
  {name: 'Starke County', fips: '18149'},
  {name: 'Steuben County', fips: '18151'},
  {name: 'Sullivan County', fips: '18153'},
  {name: 'Switzerland County', fips: '18155'},
  {name: 'Tippecanoe County', fips: '18157'},
  {name: 'Tipton County', fips: '18159'},
  {name: 'Union County', fips: '18161'},
  {name: 'Vanderburgh County', fips: '18163'},
  {name: 'Vermillion County', fips: '18165'},
  {name: 'Vigo County', fips: '18167'},
  {name: 'Wabash County', fips: '18169'},
  {name: 'Warren County', fips: '18171'},
  {name: 'Warrick County', fips: '18173'},
  {name: 'Washington County', fips: '18175'},
  {name: 'Wayne County', fips: '18177'},
  {name: 'Wells County', fips: '18179'},
  {name: 'White County', fips: '18181'},
  {name: 'Whitley County', fips: '18183'},

  // Iowa (19)
  {name: 'Adair County', fips: '19001'},
  {name: 'Adams County', fips: '19003'},
  {name: 'Allamakee County', fips: '19005'},
  {name: 'Appanoose County', fips: '19007'},
  {name: 'Audubon County', fips: '19009'},
  {name: 'Benton County', fips: '19011'},
  {name: 'Black Hawk County', fips: '19013'},
  {name: 'Boone County', fips: '19015'},
  {name: 'Bremer County', fips: '19017'},
  {name: 'Buchanan County', fips: '19019'},
  {name: 'Buena Vista County', fips: '19021'},
  {name: 'Butler County', fips: '19023'},
  {name: 'Calhoun County', fips: '19025'},
  {name: 'Carroll County', fips: '19027'},
  {name: 'Cass County', fips: '19029'},
  {name: 'Cedar County', fips: '19031'},
  {name: 'Cerro Gordo County', fips: '19033'},
  {name: 'Cherokee County', fips: '19035'},
  {name: 'Chickasaw County', fips: '19037'},
  {name: 'Clarke County', fips: '19039'},
  {name: 'Clay County', fips: '19041'},
  {name: 'Clayton County', fips: '19043'},
  {name: 'Clinton County', fips: '19045'},
  {name: 'Crawford County', fips: '19047'},
  {name: 'Dallas County', fips: '19049'},
  {name: 'Davis County', fips: '19051'},
  {name: 'Decatur County', fips: '19053'},
  {name: 'Delaware County', fips: '19055'},
  {name: 'Des Moines County', fips: '19057'},
  {name: 'Dickinson County', fips: '19059'},
  {name: 'Dubuque County', fips: '19061'},
  {name: 'Emmet County', fips: '19063'},
  {name: 'Fayette County', fips: '19065'},
  {name: 'Floyd County', fips: '19067'},
  {name: 'Franklin County', fips: '19069'},
  {name: 'Fremont County', fips: '19071'},
  {name: 'Greene County', fips: '19073'},
  {name: 'Grundy County', fips: '19075'},
  {name: 'Guthrie County', fips: '19077'},
  {name: 'Hamilton County', fips: '19079'},
  {name: 'Hancock County', fips: '19081'},
  {name: 'Hardin County', fips: '19083'},
  {name: 'Harrison County', fips: '19085'},
  {name: 'Henry County', fips: '19087'},
  {name: 'Howard County', fips: '19089'},
  {name: 'Humboldt County', fips: '19091'},
  {name: 'Ida County', fips: '19093'},
  {name: 'Iowa County', fips: '19095'},
  {name: 'Jackson County', fips: '19097'},
  {name: 'Jasper County', fips: '19099'},
  {name: 'Jefferson County', fips: '19101'},
  {name: 'Johnson County', fips: '19103'},
  {name: 'Jones County', fips: '19105'},
  {name: 'Keokuk County', fips: '19107'},
  {name: 'Kossuth County', fips: '19109'},
  {name: 'Lee County', fips: '19111'},
  {name: 'Linn County', fips: '19113'},
  {name: 'Louisa County', fips: '19115'},
  {name: 'Lucas County', fips: '19117'},
  {name: 'Lyon County', fips: '19119'},
  {name: 'Madison County', fips: '19121'},
  {name: 'Mahaska County', fips: '19123'},
  {name: 'Marion County', fips: '19125'},
  {name: 'Marshall County', fips: '19127'},
  {name: 'Mills County', fips: '19129'},
  {name: 'Mitchell County', fips: '19131'},
  {name: 'Monona County', fips: '19133'},
  {name: 'Monroe County', fips: '19135'},
  {name: 'Montgomery County', fips: '19137'},
  {name: 'Muscatine County', fips: '19139'},
  {name: "O'Brien County", fips: '19141'},
  {name: 'Osceola County', fips: '19143'},
  {name: 'Page County', fips: '19145'},
  {name: 'Palo Alto County', fips: '19147'},
  {name: 'Plymouth County', fips: '19149'},
  {name: 'Pocahontas County', fips: '19151'},
  {name: 'Polk County', fips: '19153'},
  {name: 'Pottawattamie County', fips: '19155'},
  {name: 'Poweshiek County', fips: '19157'},
  {name: 'Ringgold County', fips: '19159'},
  {name: 'Sac County', fips: '19161'},
  {name: 'Scott County', fips: '19163'},
  {name: 'Shelby County', fips: '19165'},
  {name: 'Sioux County', fips: '19167'},
  {name: 'Story County', fips: '19169'},
  {name: 'Tama County', fips: '19171'},
  {name: 'Taylor County', fips: '19173'},
  {name: 'Union County', fips: '19175'},
  {name: 'Van Buren County', fips: '19177'},
  {name: 'Wapello County', fips: '19179'},
  {name: 'Warren County', fips: '19181'},
  {name: 'Washington County', fips: '19183'},
  {name: 'Wayne County', fips: '19185'},
  {name: 'Webster County', fips: '19187'},
  {name: 'Winnebago County', fips: '19189'},
  {name: 'Winneshiek County', fips: '19191'},
  {name: 'Woodbury County', fips: '19193'},
  {name: 'Worth County', fips: '19195'},
  {name: 'Wright County', fips: '19197'},

  // Kansas (20)
  {name: 'Allen County', fips: '20001'},
  {name: 'Anderson County', fips: '20003'},
  {name: 'Atchison County', fips: '20005'},
  {name: 'Barber County', fips: '20007'},
  {name: 'Barton County', fips: '20009'},
  {name: 'Bourbon County', fips: '20011'},
  {name: 'Brown County', fips: '20013'},
  {name: 'Butler County', fips: '20015'},
  {name: 'Chase County', fips: '20017'},
  {name: 'Chautauqua County', fips: '20019'},
  {name: 'Cherokee County', fips: '20021'},
  {name: 'Cheyenne County', fips: '20023'},
  {name: 'Clark County', fips: '20025'},
  {name: 'Clay County', fips: '20027'},
  {name: 'Cloud County', fips: '20029'},
  {name: 'Coffey County', fips: '20031'},
  {name: 'Comanche County', fips: '20033'},
  {name: 'Cowley County', fips: '20035'},
  {name: 'Crawford County', fips: '20037'},
  {name: 'Decatur County', fips: '20039'},
  {name: 'Dickinson County', fips: '20041'},
  {name: 'Doniphan County', fips: '20043'},
  {name: 'Douglas County', fips: '20045'},
  {name: 'Edwards County', fips: '20047'},
  {name: 'Elk County', fips: '20049'},
  {name: 'Ellis County', fips: '20051'},
  {name: 'Ellsworth County', fips: '20053'},
  {name: 'Finney County', fips: '20055'},
  {name: 'Ford County', fips: '20057'},
  {name: 'Franklin County', fips: '20059'},
  {name: 'Geary County', fips: '20061'},
  {name: 'Gove County', fips: '20063'},
  {name: 'Graham County', fips: '20065'},
  {name: 'Grant County', fips: '20067'},
  {name: 'Gray County', fips: '20069'},
  {name: 'Greeley County', fips: '20071'},
  {name: 'Greenwood County', fips: '20073'},
  {name: 'Hamilton County', fips: '20075'},
  {name: 'Harper County', fips: '20077'},
  {name: 'Harvey County', fips: '20079'},
  {name: 'Haskell County', fips: '20081'},
  {name: 'Hodgeman County', fips: '20083'},
  {name: 'Jackson County', fips: '20085'},
  {name: 'Jefferson County', fips: '20087'},
  {name: 'Jewell County', fips: '20089'},
  {name: 'Johnson County', fips: '20091'},
  {name: 'Kearny County', fips: '20093'},
  {name: 'Kingman County', fips: '20095'},
  {name: 'Kiowa County', fips: '20097'},
  {name: 'Labette County', fips: '20099'},
  {name: 'Lane County', fips: '20101'},
  {name: 'Leavenworth County', fips: '20103'},
  {name: 'Lincoln County', fips: '20105'},
  {name: 'Linn County', fips: '20107'},
  {name: 'Logan County', fips: '20109'},
  {name: 'Lyon County', fips: '20111'},
  {name: 'McPherson County', fips: '20113'},
  {name: 'Marion County', fips: '20115'},
  {name: 'Marshall County', fips: '20117'},
  {name: 'Meade County', fips: '20119'},
  {name: 'Miami County', fips: '20121'},
  {name: 'Mitchell County', fips: '20123'},
  {name: 'Montgomery County', fips: '20125'},
  {name: 'Morris County', fips: '20127'},
  {name: 'Morton County', fips: '20129'},
  {name: 'Nemaha County', fips: '20131'},
  {name: 'Neosho County', fips: '20133'},
  {name: 'Ness County', fips: '20135'},
  {name: 'Norton County', fips: '20137'},
  {name: 'Osage County', fips: '20139'},
  {name: 'Osborne County', fips: '20141'},
  {name: 'Ottawa County', fips: '20143'},
  {name: 'Pawnee County', fips: '20145'},
  {name: 'Phillips County', fips: '20147'},
  {name: 'Pottawatomie County', fips: '20149'},
  {name: 'Pratt County', fips: '20151'},
  {name: 'Rawlins County', fips: '20153'},
  {name: 'Reno County', fips: '20155'},
  {name: 'Republic County', fips: '20157'},
  {name: 'Rice County', fips: '20159'},
  {name: 'Riley County', fips: '20161'},
  {name: 'Rooks County', fips: '20163'},
  {name: 'Rush County', fips: '20165'},
  {name: 'Russell County', fips: '20167'},
  {name: 'Saline County', fips: '20169'},
  {name: 'Scott County', fips: '20171'},
  {name: 'Sedgwick County', fips: '20173'},
  {name: 'Seward County', fips: '20175'},
  {name: 'Shawnee County', fips: '20177'},
  {name: 'Sheridan County', fips: '20179'},
  {name: 'Sherman County', fips: '20181'},
  {name: 'Smith County', fips: '20183'},
  {name: 'Stafford County', fips: '20185'},
  {name: 'Stanton County', fips: '20187'},
  {name: 'Stevens County', fips: '20189'},
  {name: 'Sumner County', fips: '20191'},
  {name: 'Thomas County', fips: '20193'},
  {name: 'Trego County', fips: '20195'},
  {name: 'Wabaunsee County', fips: '20197'},
  {name: 'Wallace County', fips: '20199'},
  {name: 'Washington County', fips: '20201'},
  {name: 'Wichita County', fips: '20203'},
  {name: 'Wilson County', fips: '20205'},
  {name: 'Woodson County', fips: '20207'},
  {name: 'Wyandotte County', fips: '20209'},

  // Kentucky (21)
  {name: 'Adair County', fips: '21001'},
  {name: 'Allen County', fips: '21003'},
  {name: 'Anderson County', fips: '21005'},
  {name: 'Ballard County', fips: '21007'},
  {name: 'Barren County', fips: '21009'},
  {name: 'Bath County', fips: '21011'},
  {name: 'Bell County', fips: '21013'},
  {name: 'Boone County', fips: '21015'},
  {name: 'Bourbon County', fips: '21017'},
  {name: 'Boyd County', fips: '21019'},
  {name: 'Boyle County', fips: '21021'},
  {name: 'Bracken County', fips: '21023'},
  {name: 'Breathitt County', fips: '21025'},
  {name: 'Breckinridge County', fips: '21027'},
  {name: 'Bullitt County', fips: '21029'},
  {name: 'Butler County', fips: '21031'},
  {name: 'Caldwell County', fips: '21033'},
  {name: 'Calloway County', fips: '21035'},
  {name: 'Campbell County', fips: '21037'},
  {name: 'Carlisle County', fips: '21039'},
  {name: 'Carroll County', fips: '21041'},
  {name: 'Carter County', fips: '21043'},
  {name: 'Casey County', fips: '21045'},
  {name: 'Christian County', fips: '21047'},
  {name: 'Clark County', fips: '21049'},
  {name: 'Clay County', fips: '21051'},
  {name: 'Clinton County', fips: '21053'},
  {name: 'Crittenden County', fips: '21055'},
  {name: 'Cumberland County', fips: '21057'},
  {name: 'Daviess County', fips: '21059'},
  {name: 'Edmonson County', fips: '21061'},
  {name: 'Elliott County', fips: '21063'},
  {name: 'Estill County', fips: '21065'},
  {name: 'Fayette County', fips: '21067'},
  {name: 'Fleming County', fips: '21069'},
  {name: 'Floyd County', fips: '21071'},
  {name: 'Franklin County', fips: '21073'},
  {name: 'Fulton County', fips: '21075'},
  {name: 'Gallatin County', fips: '21077'},
  {name: 'Garrard County', fips: '21079'},
  {name: 'Grant County', fips: '21081'},
  {name: 'Graves County', fips: '21083'},
  {name: 'Grayson County', fips: '21085'},
  {name: 'Green County', fips: '21087'},
  {name: 'Greenup County', fips: '21089'},
  {name: 'Hancock County', fips: '21091'},
  {name: 'Hardin County', fips: '21093'},
  {name: 'Harlan County', fips: '21095'},
  {name: 'Harrison County', fips: '21097'},
  {name: 'Hart County', fips: '21099'},
  {name: 'Henderson County', fips: '21101'},
  {name: 'Henry County', fips: '21103'},
  {name: 'Hickman County', fips: '21105'},
  {name: 'Hopkins County', fips: '21107'},
  {name: 'Jackson County', fips: '21109'},
  {name: 'Jefferson County', fips: '21111'},
  {name: 'Jessamine County', fips: '21113'},
  {name: 'Johnson County', fips: '21115'},
  {name: 'Kenton County', fips: '21117'},
  {name: 'Knott County', fips: '21119'},
  {name: 'Knox County', fips: '21121'},
  {name: 'Larue County', fips: '21123'},
  {name: 'Laurel County', fips: '21125'},
  {name: 'Lawrence County', fips: '21127'},
  {name: 'Lee County', fips: '21129'},
  {name: 'Leslie County', fips: '21131'},
  {name: 'Letcher County', fips: '21133'},
  {name: 'Lewis County', fips: '21135'},
  {name: 'Lincoln County', fips: '21137'},
  {name: 'Livingston County', fips: '21139'},
  {name: 'Logan County', fips: '21141'},
  {name: 'Lyon County', fips: '21143'},
  {name: 'McCracken County', fips: '21145'},
  {name: 'McCreary County', fips: '21147'},
  {name: 'McLean County', fips: '21149'},
  {name: 'Madison County', fips: '21151'},
  {name: 'Magoffin County', fips: '21153'},
  {name: 'Marion County', fips: '21155'},
  {name: 'Marshall County', fips: '21157'},
  {name: 'Martin County', fips: '21159'},
  {name: 'Mason County', fips: '21161'},
  {name: 'Meade County', fips: '21163'},
  {name: 'Menifee County', fips: '21165'},
  {name: 'Mercer County', fips: '21167'},
  {name: 'Metcalfe County', fips: '21169'},
  {name: 'Monroe County', fips: '21171'},
  {name: 'Montgomery County', fips: '21173'},
  {name: 'Morgan County', fips: '21175'},
  {name: 'Muhlenberg County', fips: '21177'},
  {name: 'Nelson County', fips: '21179'},
  {name: 'Nicholas County', fips: '21181'},
  {name: 'Ohio County', fips: '21183'},
  {name: 'Oldham County', fips: '21185'},
  {name: 'Owen County', fips: '21187'},
  {name: 'Owsley County', fips: '21189'},
  {name: 'Pendleton County', fips: '21191'},
  {name: 'Perry County', fips: '21193'},
  {name: 'Pike County', fips: '21195'},
  {name: 'Powell County', fips: '21197'},
  {name: 'Pulaski County', fips: '21199'},
  {name: 'Robertson County', fips: '21201'},
  {name: 'Rockcastle County', fips: '21203'},
  {name: 'Rowan County', fips: '21205'},
  {name: 'Russell County', fips: '21207'},
  {name: 'Scott County', fips: '21209'},
  {name: 'Shelby County', fips: '21211'},
  {name: 'Simpson County', fips: '21213'},
  {name: 'Spencer County', fips: '21215'},
  {name: 'Taylor County', fips: '21217'},
  {name: 'Todd County', fips: '21219'},
  {name: 'Trigg County', fips: '21221'},
  {name: 'Trimble County', fips: '21223'},
  {name: 'Union County', fips: '21225'},
  {name: 'Warren County', fips: '21227'},
  {name: 'Washington County', fips: '21229'},
  {name: 'Wayne County', fips: '21231'},
  {name: 'Webster County', fips: '21233'},
  {name: 'Whitley County', fips: '21235'},
  {name: 'Wolfe County', fips: '21237'},
  {name: 'Woodford County', fips: '21239'},

  // Louisiana (22)
  {name: 'Acadia Parish', fips: '22001'},
  {name: 'Allen Parish', fips: '22003'},
  {name: 'Ascension Parish', fips: '22005'},
  {name: 'Assumption Parish', fips: '22007'},
  {name: 'Avoyelles Parish', fips: '22009'},
  {name: 'Beauregard Parish', fips: '22011'},
  {name: 'Bienville Parish', fips: '22013'},
  {name: 'Bossier Parish', fips: '22015'},
  {name: 'Caddo Parish', fips: '22017'},
  {name: 'Calcasieu Parish', fips: '22019'},
  {name: 'Caldwell Parish', fips: '22021'},
  {name: 'Cameron Parish', fips: '22023'},
  {name: 'Catahoula Parish', fips: '22025'},
  {name: 'Claiborne Parish', fips: '22027'},
  {name: 'Concordia Parish', fips: '22029'},
  {name: 'De Soto Parish', fips: '22031'},
  {name: 'East Baton Rouge Parish', fips: '22033'},
  {name: 'East Carroll Parish', fips: '22035'},
  {name: 'East Feliciana Parish', fips: '22037'},
  {name: 'Evangeline Parish', fips: '22039'},
  {name: 'Franklin Parish', fips: '22041'},
  {name: 'Grant Parish', fips: '22043'},
  {name: 'Iberia Parish', fips: '22045'},
  {name: 'Iberville Parish', fips: '22047'},
  {name: 'Jackson Parish', fips: '22049'},
  {name: 'Jefferson Parish', fips: '22051'},
  {name: 'Jefferson Davis Parish', fips: '22053'},
  {name: 'Lafayette Parish', fips: '22055'},
  {name: 'Lafourche Parish', fips: '22057'},
  {name: 'LaSalle Parish', fips: '22059'},
  {name: 'Lincoln Parish', fips: '22061'},
  {name: 'Livingston Parish', fips: '22063'},
  {name: 'Madison Parish', fips: '22065'},
  {name: 'Morehouse Parish', fips: '22067'},
  {name: 'Natchitoches Parish', fips: '22069'},
  {name: 'Orleans Parish', fips: '22071'},
  {name: 'Ouachita Parish', fips: '22073'},
  {name: 'Plaquemines Parish', fips: '22075'},
  {name: 'Pointe Coupee Parish', fips: '22077'},
  {name: 'Rapides Parish', fips: '22079'},
  {name: 'Red River Parish', fips: '22081'},
  {name: 'Richland Parish', fips: '22083'},
  {name: 'Sabine Parish', fips: '22085'},
  {name: 'St. Bernard Parish', fips: '22087'},
  {name: 'St. Charles Parish', fips: '22089'},
  {name: 'St. Helena Parish', fips: '22091'},
  {name: 'St. James Parish', fips: '22093'},
  {name: 'St. John the Baptist Parish', fips: '22095'},
  {name: 'St. Landry Parish', fips: '22097'},
  {name: 'St. Martin Parish', fips: '22099'},
  {name: 'St. Mary Parish', fips: '22101'},
  {name: 'St. Tammany Parish', fips: '22103'},
  {name: 'Tangipahoa Parish', fips: '22105'},
  {name: 'Tensas Parish', fips: '22107'},
  {name: 'Terrebonne Parish', fips: '22109'},
  {name: 'Union Parish', fips: '22111'},
  {name: 'Vermilion Parish', fips: '22113'},
  {name: 'Vernon Parish', fips: '22115'},
  {name: 'Washington Parish', fips: '22117'},
  {name: 'Webster Parish', fips: '22119'},
  {name: 'West Baton Rouge Parish', fips: '22121'},
  {name: 'West Carroll Parish', fips: '22123'},
  {name: 'West Feliciana Parish', fips: '22125'},
  {name: 'Winn Parish', fips: '22127'},

  // Maine (23)
  {name: 'Androscoggin County', fips: '23001'},
  {name: 'Aroostook County', fips: '23003'},
  {name: 'Cumberland County', fips: '23005'},
  {name: 'Franklin County', fips: '23007'},
  {name: 'Hancock County', fips: '23009'},
  {name: 'Kennebec County', fips: '23011'},
  {name: 'Knox County', fips: '23013'},
  {name: 'Lincoln County', fips: '23015'},
  {name: 'Oxford County', fips: '23017'},
  {name: 'Penobscot County', fips: '23019'},
  {name: 'Piscataquis County', fips: '23021'},
  {name: 'Sagadahoc County', fips: '23023'},
  {name: 'Somerset County', fips: '23025'},
  {name: 'Waldo County', fips: '23027'},
  {name: 'Washington County', fips: '23029'},
  {name: 'York County', fips: '23031'},

  // Maryland (24)
  {name: 'Allegany County', fips: '24001'},
  {name: 'Anne Arundel County', fips: '24003'},
  {name: 'Baltimore County', fips: '24005'},
  {name: 'Calvert County', fips: '24009'},
  {name: 'Caroline County', fips: '24011'},
  {name: 'Carroll County', fips: '24013'},
  {name: 'Cecil County', fips: '24015'},
  {name: 'Charles County', fips: '24017'},
  {name: 'Dorchester County', fips: '24019'},
  {name: 'Frederick County', fips: '24021'},
  {name: 'Garrett County', fips: '24023'},
  {name: 'Harford County', fips: '24025'},
  {name: 'Howard County', fips: '24027'},
  {name: 'Kent County', fips: '24029'},
  {name: 'Montgomery County', fips: '24031'},
  {name: "Prince George's County", fips: '24033'},
  {name: "Queen Anne's County", fips: '24035'},
  {name: "St. Mary's County", fips: '24037'},
  {name: 'Somerset County', fips: '24039'},
  {name: 'Talbot County', fips: '24041'},
  {name: 'Washington County', fips: '24043'},
  {name: 'Wicomico County', fips: '24045'},
  {name: 'Worcester County', fips: '24047'},
  {name: 'Baltimore city', fips: '24510'},

  // Massachusetts (25)
  {name: 'Barnstable County', fips: '25001'},
  {name: 'Berkshire County', fips: '25003'},
  {name: 'Bristol County', fips: '25005'},
  {name: 'Dukes County', fips: '25007'},
  {name: 'Essex County', fips: '25009'},
  {name: 'Franklin County', fips: '25011'},
  {name: 'Hampden County', fips: '25013'},
  {name: 'Hampshire County', fips: '25015'},
  {name: 'Middlesex County', fips: '25017'},
  {name: 'Nantucket County', fips: '25019'},
  {name: 'Norfolk County', fips: '25021'},
  {name: 'Plymouth County', fips: '25023'},
  {name: 'Suffolk County', fips: '25025'},
  {name: 'Worcester County', fips: '25027'},

  // Michigan (26)
  {name: 'Alcona County', fips: '26001'},
  {name: 'Alger County', fips: '26003'},
  {name: 'Allegan County', fips: '26005'},
  {name: 'Alpena County', fips: '26007'},
  {name: 'Antrim County', fips: '26009'},
  {name: 'Arenac County', fips: '26011'},
  {name: 'Baraga County', fips: '26013'},
  {name: 'Barry County', fips: '26015'},
  {name: 'Bay County', fips: '26017'},
  {name: 'Benzie County', fips: '26019'},
  {name: 'Berrien County', fips: '26021'},
  {name: 'Branch County', fips: '26023'},
  {name: 'Calhoun County', fips: '26025'},
  {name: 'Cass County', fips: '26027'},
  {name: 'Charlevoix County', fips: '26029'},
  {name: 'Cheboygan County', fips: '26031'},
  {name: 'Chippewa County', fips: '26033'},
  {name: 'Clare County', fips: '26035'},
  {name: 'Clinton County', fips: '26037'},
  {name: 'Crawford County', fips: '26039'},
  {name: 'Delta County', fips: '26041'},
  {name: 'Dickinson County', fips: '26043'},
  {name: 'Eaton County', fips: '26045'},
  {name: 'Emmet County', fips: '26047'},
  {name: 'Genesee County', fips: '26049'},
  {name: 'Gladwin County', fips: '26051'},
  {name: 'Gogebic County', fips: '26053'},
  {name: 'Grand Traverse County', fips: '26055'},
  {name: 'Gratiot County', fips: '26057'},
  {name: 'Hillsdale County', fips: '26059'},
  {name: 'Houghton County', fips: '26061'},
  {name: 'Huron County', fips: '26063'},
  {name: 'Ingham County', fips: '26065'},
  {name: 'Ionia County', fips: '26067'},
  {name: 'Iosco County', fips: '26069'},
  {name: 'Iron County', fips: '26071'},
  {name: 'Isabella County', fips: '26073'},
  {name: 'Jackson County', fips: '26075'},
  {name: 'Kalamazoo County', fips: '26077'},
  {name: 'Kalkaska County', fips: '26079'},
  {name: 'Kent County', fips: '26081'},
  {name: 'Keweenaw County', fips: '26083'},
  {name: 'Lake County', fips: '26085'},
  {name: 'Lapeer County', fips: '26087'},
  {name: 'Leelanau County', fips: '26089'},
  {name: 'Lenawee County', fips: '26091'},
  {name: 'Livingston County', fips: '26093'},
  {name: 'Luce County', fips: '26095'},
  {name: 'Mackinac County', fips: '26097'},
  {name: 'Macomb County', fips: '26099'},
  {name: 'Manistee County', fips: '26101'},
  {name: 'Marquette County', fips: '26103'},
  {name: 'Mason County', fips: '26105'},
  {name: 'Mecosta County', fips: '26107'},
  {name: 'Menominee County', fips: '26109'},
  {name: 'Midland County', fips: '26111'},
  {name: 'Missaukee County', fips: '26113'},
  {name: 'Monroe County', fips: '26115'},
  {name: 'Montcalm County', fips: '26117'},
  {name: 'Montmorency County', fips: '26119'},
  {name: 'Muskegon County', fips: '26121'},
  {name: 'Newaygo County', fips: '26123'},
  {name: 'Oakland County', fips: '26125'},
  {name: 'Oceana County', fips: '26127'},
  {name: 'Ogemaw County', fips: '26129'},
  {name: 'Ontonagon County', fips: '26131'},
  {name: 'Osceola County', fips: '26133'},
  {name: 'Oscoda County', fips: '26135'},
  {name: 'Otsego County', fips: '26137'},
  {name: 'Ottawa County', fips: '26139'},
  {name: 'Presque Isle County', fips: '26141'},
  {name: 'Roscommon County', fips: '26143'},
  {name: 'Saginaw County', fips: '26145'},
  {name: 'St. Clair County', fips: '26147'},
  {name: 'St. Joseph County', fips: '26149'},
  {name: 'Sanilac County', fips: '26151'},
  {name: 'Schoolcraft County', fips: '26153'},
  {name: 'Shiawassee County', fips: '26155'},
  {name: 'Tuscola County', fips: '26157'},
  {name: 'Van Buren County', fips: '26159'},
  {name: 'Washtenaw County', fips: '26161'},
  {name: 'Wayne County', fips: '26163'},
  {name: 'Wexford County', fips: '26165'},

  // Minnesota (27)
  {name: 'Aitkin County', fips: '27001'},
  {name: 'Anoka County', fips: '27003'},
  {name: 'Becker County', fips: '27005'},
  {name: 'Beltrami County', fips: '27007'},
  {name: 'Benton County', fips: '27009'},
  {name: 'Big Stone County', fips: '27011'},
  {name: 'Blue Earth County', fips: '27013'},
  {name: 'Brown County', fips: '27015'},
  {name: 'Carlton County', fips: '27017'},
  {name: 'Carver County', fips: '27019'},
  {name: 'Cass County', fips: '27021'},
  {name: 'Chippewa County', fips: '27023'},
  {name: 'Chisago County', fips: '27025'},
  {name: 'Clay County', fips: '27027'},
  {name: 'Clearwater County', fips: '27029'},
  {name: 'Cook County', fips: '27031'},
  {name: 'Cottonwood County', fips: '27033'},
  {name: 'Crow Wing County', fips: '27035'},
  {name: 'Dakota County', fips: '27037'},
  {name: 'Dodge County', fips: '27039'},
  {name: 'Douglas County', fips: '27041'},
  {name: 'Faribault County', fips: '27043'},
  {name: 'Fillmore County', fips: '27045'},
  {name: 'Freeborn County', fips: '27047'},
  {name: 'Goodhue County', fips: '27049'},
  {name: 'Grant County', fips: '27051'},
  {name: 'Hennepin County', fips: '27053'},
  {name: 'Houston County', fips: '27055'},
  {name: 'Hubbard County', fips: '27057'},
  {name: 'Isanti County', fips: '27059'},
  {name: 'Itasca County', fips: '27061'},
  {name: 'Jackson County', fips: '27063'},
  {name: 'Kanabec County', fips: '27065'},
  {name: 'Kandiyohi County', fips: '27067'},
  {name: 'Kittson County', fips: '27069'},
  {name: 'Koochiching County', fips: '27071'},
  {name: 'Lac qui Parle County', fips: '27073'},
  {name: 'Lake County', fips: '27075'},
  {name: 'Lake of the Woods County', fips: '27077'},
  {name: 'Le Sueur County', fips: '27079'},
  {name: 'Lincoln County', fips: '27081'},
  {name: 'Lyon County', fips: '27083'},
  {name: 'McLeod County', fips: '27085'},
  {name: 'Mahnomen County', fips: '27087'},
  {name: 'Marshall County', fips: '27089'},
  {name: 'Martin County', fips: '27091'},
  {name: 'Meeker County', fips: '27093'},
  {name: 'Mille Lacs County', fips: '27095'},
  {name: 'Morrison County', fips: '27097'},
  {name: 'Mower County', fips: '27099'},
  {name: 'Murray County', fips: '27101'},
  {name: 'Nicollet County', fips: '27103'},
  {name: 'Nobles County', fips: '27105'},
  {name: 'Norman County', fips: '27107'},
  {name: 'Olmsted County', fips: '27109'},
  {name: 'Otter Tail County', fips: '27111'},
  {name: 'Pennington County', fips: '27113'},
  {name: 'Pine County', fips: '27115'},
  {name: 'Pipestone County', fips: '27117'},
  {name: 'Polk County', fips: '27119'},
  {name: 'Pope County', fips: '27121'},
  {name: 'Ramsey County', fips: '27123'},
  {name: 'Red Lake County', fips: '27125'},
  {name: 'Redwood County', fips: '27127'},
  {name: 'Renville County', fips: '27129'},
  {name: 'Rice County', fips: '27131'},
  {name: 'Rock County', fips: '27133'},
  {name: 'Roseau County', fips: '27135'},
  {name: 'St. Louis County', fips: '27137'},
  {name: 'Scott County', fips: '27139'},
  {name: 'Sherburne County', fips: '27141'},
  {name: 'Sibley County', fips: '27143'},
  {name: 'Stearns County', fips: '27145'},
  {name: 'Steele County', fips: '27147'},
  {name: 'Stevens County', fips: '27149'},
  {name: 'Swift County', fips: '27151'},
  {name: 'Todd County', fips: '27153'},
  {name: 'Traverse County', fips: '27155'},
  {name: 'Wabasha County', fips: '27157'},
  {name: 'Wadena County', fips: '27159'},
  {name: 'Waseca County', fips: '27161'},
  {name: 'Washington County', fips: '27163'},
  {name: 'Watonwan County', fips: '27165'},
  {name: 'Wilkin County', fips: '27167'},
  {name: 'Winona County', fips: '27169'},
  {name: 'Wright County', fips: '27171'},
  {name: 'Yellow Medicine County', fips: '27173'},

  // Mississippi (28)
  {name: 'Adams County', fips: '28001'},
  {name: 'Alcorn County', fips: '28003'},
  {name: 'Amite County', fips: '28005'},
  {name: 'Attala County', fips: '28007'},
  {name: 'Benton County', fips: '28009'},
  {name: 'Bolivar County', fips: '28011'},
  {name: 'Calhoun County', fips: '28013'},
  {name: 'Carroll County', fips: '28015'},
  {name: 'Chickasaw County', fips: '28017'},
  {name: 'Choctaw County', fips: '28019'},
  {name: 'Claiborne County', fips: '28021'},
  {name: 'Clarke County', fips: '28023'},
  {name: 'Clay County', fips: '28025'},
  {name: 'Coahoma County', fips: '28027'},
  {name: 'Copiah County', fips: '28029'},
  {name: 'Covington County', fips: '28031'},
  {name: 'DeSoto County', fips: '28033'},
  {name: 'Forrest County', fips: '28035'},
  {name: 'Franklin County', fips: '28037'},
  {name: 'George County', fips: '28039'},
  {name: 'Greene County', fips: '28041'},
  {name: 'Grenada County', fips: '28043'},
  {name: 'Hancock County', fips: '28045'},
  {name: 'Harrison County', fips: '28047'},
  {name: 'Hinds County', fips: '28049'},
  {name: 'Holmes County', fips: '28051'},
  {name: 'Humphreys County', fips: '28053'},
  {name: 'Issaquena County', fips: '28055'},
  {name: 'Itawamba County', fips: '28057'},
  {name: 'Jackson County', fips: '28059'},
  {name: 'Jasper County', fips: '28061'},
  {name: 'Jefferson County', fips: '28063'},
  {name: 'Jefferson Davis County', fips: '28065'},
  {name: 'Jones County', fips: '28067'},
  {name: 'Kemper County', fips: '28069'},
  {name: 'Lafayette County', fips: '28071'},
  {name: 'Lamar County', fips: '28073'},
  {name: 'Lauderdale County', fips: '28075'},
  {name: 'Lawrence County', fips: '28077'},
  {name: 'Leake County', fips: '28079'},
  {name: 'Lee County', fips: '28081'},
  {name: 'Leflore County', fips: '28083'},
  {name: 'Lincoln County', fips: '28085'},
  {name: 'Lowndes County', fips: '28087'},
  {name: 'Madison County', fips: '28089'},
  {name: 'Marion County', fips: '28091'},
  {name: 'Marshall County', fips: '28093'},
  {name: 'Monroe County', fips: '28095'},
  {name: 'Montgomery County', fips: '28097'},
  {name: 'Neshoba County', fips: '28099'},
  {name: 'Newton County', fips: '28101'},
  {name: 'Noxubee County', fips: '28103'},
  {name: 'Oktibbeha County', fips: '28105'},
  {name: 'Panola County', fips: '28107'},
  {name: 'Pearl River County', fips: '28109'},
  {name: 'Perry County', fips: '28111'},
  {name: 'Pike County', fips: '28113'},
  {name: 'Pontotoc County', fips: '28115'},
  {name: 'Prentiss County', fips: '28117'},
  {name: 'Quitman County', fips: '28119'},
  {name: 'Rankin County', fips: '28121'},
  {name: 'Scott County', fips: '28123'},
  {name: 'Sharkey County', fips: '28125'},
  {name: 'Simpson County', fips: '28127'},
  {name: 'Smith County', fips: '28129'},
  {name: 'Stone County', fips: '28131'},
  {name: 'Sunflower County', fips: '28133'},
  {name: 'Tallahatchie County', fips: '28135'},
  {name: 'Tate County', fips: '28137'},
  {name: 'Tippah County', fips: '28139'},
  {name: 'Tishomingo County', fips: '28141'},
  {name: 'Tunica County', fips: '28143'},
  {name: 'Union County', fips: '28145'},
  {name: 'Walthall County', fips: '28147'},
  {name: 'Warren County', fips: '28149'},
  {name: 'Washington County', fips: '28151'},
  {name: 'Wayne County', fips: '28153'},
  {name: 'Webster County', fips: '28155'},
  {name: 'Wilkinson County', fips: '28157'},
  {name: 'Winston County', fips: '28159'},
  {name: 'Yalobusha County', fips: '28161'},
  {name: 'Yazoo County', fips: '28163'},

  // Missouri (29)
  {name: 'Adair County', fips: '29001'},
  {name: 'Andrew County', fips: '29003'},
  {name: 'Atchison County', fips: '29005'},
  {name: 'Audrain County', fips: '29007'},
  {name: 'Barry County', fips: '29009'},
  {name: 'Barton County', fips: '29011'},
  {name: 'Bates County', fips: '29013'},
  {name: 'Benton County', fips: '29015'},
  {name: 'Bollinger County', fips: '29017'},
  {name: 'Boone County', fips: '29019'},
  {name: 'Buchanan County', fips: '29021'},
  {name: 'Butler County', fips: '29023'},
  {name: 'Caldwell County', fips: '29025'},
  {name: 'Callaway County', fips: '29027'},
  {name: 'Camden County', fips: '29029'},
  {name: 'Cape Girardeau County', fips: '29031'},
  {name: 'Carroll County', fips: '29033'},
  {name: 'Carter County', fips: '29035'},
  {name: 'Cass County', fips: '29037'},
  {name: 'Cedar County', fips: '29039'},
  {name: 'Chariton County', fips: '29041'},
  {name: 'Christian County', fips: '29043'},
  {name: 'Clark County', fips: '29045'},
  {name: 'Clay County', fips: '29047'},
  {name: 'Clinton County', fips: '29049'},
  {name: 'Cole County', fips: '29051'},
  {name: 'Cooper County', fips: '29053'},
  {name: 'Crawford County', fips: '29055'},
  {name: 'Dade County', fips: '29057'},
  {name: 'Dallas County', fips: '29059'},
  {name: 'Daviess County', fips: '29061'},
  {name: 'DeKalb County', fips: '29063'},
  {name: 'Dent County', fips: '29065'},
  {name: 'Douglas County', fips: '29067'},
  {name: 'Dunklin County', fips: '29069'},
  {name: 'Franklin County', fips: '29071'},
  {name: 'Gasconade County', fips: '29073'},
  {name: 'Gentry County', fips: '29075'},
  {name: 'Greene County', fips: '29077'},
  {name: 'Grundy County', fips: '29079'},
  {name: 'Harrison County', fips: '29081'},
  {name: 'Henry County', fips: '29083'},
  {name: 'Hickory County', fips: '29085'},
  {name: 'Holt County', fips: '29087'},
  {name: 'Howard County', fips: '29089'},
  {name: 'Howell County', fips: '29091'},
  {name: 'Iron County', fips: '29093'},
  {name: 'Jackson County', fips: '29095'},
  {name: 'Jasper County', fips: '29097'},
  {name: 'Jefferson County', fips: '29099'},
  {name: 'Johnson County', fips: '29101'},
  {name: 'Knox County', fips: '29103'},
  {name: 'Laclede County', fips: '29105'},
  {name: 'Lafayette County', fips: '29107'},
  {name: 'Lawrence County', fips: '29109'},
  {name: 'Lewis County', fips: '29111'},
  {name: 'Lincoln County', fips: '29113'},
  {name: 'Linn County', fips: '29115'},
  {name: 'Livingston County', fips: '29117'},
  {name: 'McDonald County', fips: '29119'},
  {name: 'Macon County', fips: '29121'},
  {name: 'Madison County', fips: '29123'},
  {name: 'Maries County', fips: '29125'},
  {name: 'Marion County', fips: '29127'},
  {name: 'Mercer County', fips: '29129'},
  {name: 'Miller County', fips: '29131'},
  {name: 'Mississippi County', fips: '29133'},
  {name: 'Moniteau County', fips: '29135'},
  {name: 'Monroe County', fips: '29137'},
  {name: 'Montgomery County', fips: '29139'},
  {name: 'Morgan County', fips: '29141'},
  {name: 'New Madrid County', fips: '29143'},
  {name: 'Newton County', fips: '29145'},
  {name: 'Nodaway County', fips: '29147'},
  {name: 'Oregon County', fips: '29149'},
  {name: 'Osage County', fips: '29151'},
  {name: 'Ozark County', fips: '29153'},
  {name: 'Pemiscot County', fips: '29155'},
  {name: 'Perry County', fips: '29157'},
  {name: 'Pettis County', fips: '29159'},
  {name: 'Phelps County', fips: '29161'},
  {name: 'Pike County', fips: '29163'},
  {name: 'Platte County', fips: '29165'},
  {name: 'Polk County', fips: '29167'},
  {name: 'Pulaski County', fips: '29169'},
  {name: 'Putnam County', fips: '29171'},
  {name: 'Ralls County', fips: '29173'},
  {name: 'Randolph County', fips: '29175'},
  {name: 'Ray County', fips: '29177'},
  {name: 'Reynolds County', fips: '29179'},
  {name: 'Ripley County', fips: '29181'},
  {name: 'St. Charles County', fips: '29183'},
  {name: 'St. Clair County', fips: '29185'},
  {name: 'Ste. Genevieve County', fips: '29186'},
  {name: 'St. Francois County', fips: '29187'},
  {name: 'St. Louis County', fips: '29189'},
  {name: 'Saline County', fips: '29195'},
  {name: 'Schuyler County', fips: '29197'},
  {name: 'Scotland County', fips: '29199'},
  {name: 'Scott County', fips: '29201'},
  {name: 'Shannon County', fips: '29203'},
  {name: 'Shelby County', fips: '29205'},
  {name: 'Stoddard County', fips: '29207'},
  {name: 'Stone County', fips: '29209'},
  {name: 'Sullivan County', fips: '29211'},
  {name: 'Taney County', fips: '29213'},
  {name: 'Texas County', fips: '29215'},
  {name: 'Vernon County', fips: '29217'},
  {name: 'Warren County', fips: '29219'},
  {name: 'Washington County', fips: '29221'},
  {name: 'Wayne County', fips: '29223'},
  {name: 'Webster County', fips: '29225'},
  {name: 'Worth County', fips: '29227'},
  {name: 'Wright County', fips: '29229'},
  {name: 'St. Louis city', fips: '29510'},

  // Montana (30)
  {name: 'Beaverhead County', fips: '30001'},
  {name: 'Big Horn County', fips: '30003'},
  {name: 'Blaine County', fips: '30005'},
  {name: 'Broadwater County', fips: '30007'},
  {name: 'Carbon County', fips: '30009'},
  {name: 'Carter County', fips: '30011'},
  {name: 'Cascade County', fips: '30013'},
  {name: 'Chouteau County', fips: '30015'},
  {name: 'Custer County', fips: '30017'},
  {name: 'Daniels County', fips: '30019'},
  {name: 'Dawson County', fips: '30021'},
  {name: 'Deer Lodge County', fips: '30023'},
  {name: 'Fallon County', fips: '30025'},
  {name: 'Fergus County', fips: '30027'},
  {name: 'Flathead County', fips: '30029'},
  {name: 'Gallatin County', fips: '30031'},
  {name: 'Garfield County', fips: '30033'},
  {name: 'Glacier County', fips: '30035'},
  {name: 'Golden Valley County', fips: '30037'},
  {name: 'Granite County', fips: '30039'},
  {name: 'Hill County', fips: '30041'},
  {name: 'Jefferson County', fips: '30043'},
  {name: 'Judith Basin County', fips: '30045'},
  {name: 'Lake County', fips: '30047'},
  {name: 'Lewis and Clark County', fips: '30049'},
  {name: 'Liberty County', fips: '30051'},
  {name: 'Lincoln County', fips: '30053'},
  {name: 'McCone County', fips: '30055'},
  {name: 'Madison County', fips: '30057'},
  {name: 'Meagher County', fips: '30059'},
  {name: 'Mineral County', fips: '30061'},
  {name: 'Missoula County', fips: '30063'},
  {name: 'Musselshell County', fips: '30065'},
  {name: 'Park County', fips: '30067'},
  {name: 'Petroleum County', fips: '30069'},
  {name: 'Phillips County', fips: '30071'},
  {name: 'Pondera County', fips: '30073'},
  {name: 'Powder River County', fips: '30075'},
  {name: 'Powell County', fips: '30077'},
  {name: 'Prairie County', fips: '30079'},
  {name: 'Ravalli County', fips: '30081'},
  {name: 'Richland County', fips: '30083'},
  {name: 'Roosevelt County', fips: '30085'},
  {name: 'Rosebud County', fips: '30087'},
  {name: 'Sanders County', fips: '30089'},
  {name: 'Sheridan County', fips: '30091'},
  {name: 'Silver Bow County', fips: '30093'},
  {name: 'Stillwater County', fips: '30095'},
  {name: 'Sweet Grass County', fips: '30097'},
  {name: 'Teton County', fips: '30099'},
  {name: 'Toole County', fips: '30101'},
  {name: 'Treasure County', fips: '30103'},
  {name: 'Valley County', fips: '30105'},
  {name: 'Wheatland County', fips: '30107'},
  {name: 'Wibaux County', fips: '30109'},
  {name: 'Yellowstone County', fips: '30111'},

  // Nebraska (31)
  {name: 'Adams County', fips: '31001'},
  {name: 'Antelope County', fips: '31003'},
  {name: 'Arthur County', fips: '31005'},
  {name: 'Banner County', fips: '31007'},
  {name: 'Blaine County', fips: '31009'},
  {name: 'Boone County', fips: '31011'},
  {name: 'Box Butte County', fips: '31013'},
  {name: 'Boyd County', fips: '31015'},
  {name: 'Brown County', fips: '31017'},
  {name: 'Buffalo County', fips: '31019'},
  {name: 'Burt County', fips: '31021'},
  {name: 'Butler County', fips: '31023'},
  {name: 'Cass County', fips: '31025'},
  {name: 'Cedar County', fips: '31027'},
  {name: 'Chase County', fips: '31029'},
  {name: 'Cherry County', fips: '31031'},
  {name: 'Cheyenne County', fips: '31033'},
  {name: 'Clay County', fips: '31035'},
  {name: 'Colfax County', fips: '31037'},
  {name: 'Cuming County', fips: '31039'},
  {name: 'Custer County', fips: '31041'},
  {name: 'Dakota County', fips: '31043'},
  {name: 'Dawes County', fips: '31045'},
  {name: 'Dawson County', fips: '31047'},
  {name: 'Deuel County', fips: '31049'},
  {name: 'Dixon County', fips: '31051'},
  {name: 'Dodge County', fips: '31053'},
  {name: 'Douglas County', fips: '31055'},
  {name: 'Dundy County', fips: '31057'},
  {name: 'Fillmore County', fips: '31059'},
  {name: 'Franklin County', fips: '31061'},
  {name: 'Frontier County', fips: '31063'},
  {name: 'Furnas County', fips: '31065'},
  {name: 'Gage County', fips: '31067'},
  {name: 'Garden County', fips: '31069'},
  {name: 'Garfield County', fips: '31071'},
  {name: 'Gosper County', fips: '31073'},
  {name: 'Grant County', fips: '31075'},
  {name: 'Greeley County', fips: '31077'},
  {name: 'Hall County', fips: '31079'},
  {name: 'Hamilton County', fips: '31081'},
  {name: 'Harlan County', fips: '31083'},
  {name: 'Hayes County', fips: '31085'},
  {name: 'Hitchcock County', fips: '31087'},
  {name: 'Holt County', fips: '31089'},
  {name: 'Hooker County', fips: '31091'},
  {name: 'Howard County', fips: '31093'},
  {name: 'Jefferson County', fips: '31095'},
  {name: 'Johnson County', fips: '31097'},
  {name: 'Kearney County', fips: '31099'},
  {name: 'Keith County', fips: '31101'},
  {name: 'Keya Paha County', fips: '31103'},
  {name: 'Kimball County', fips: '31105'},
  {name: 'Knox County', fips: '31107'},
  {name: 'Lancaster County', fips: '31109'},
  {name: 'Lincoln County', fips: '31111'},
  {name: 'Logan County', fips: '31113'},
  {name: 'Loup County', fips: '31115'},
  {name: 'McPherson County', fips: '31117'},
  {name: 'Madison County', fips: '31119'},
  {name: 'Merrick County', fips: '31121'},
  {name: 'Morrill County', fips: '31123'},
  {name: 'Nance County', fips: '31125'},
  {name: 'Nemaha County', fips: '31127'},
  {name: 'Nuckolls County', fips: '31129'},
  {name: 'Otoe County', fips: '31131'},
  {name: 'Pawnee County', fips: '31133'},
  {name: 'Perkins County', fips: '31135'},
  {name: 'Phelps County', fips: '31137'},
  {name: 'Pierce County', fips: '31139'},
  {name: 'Platte County', fips: '31141'},
  {name: 'Polk County', fips: '31143'},
  {name: 'Red Willow County', fips: '31145'},
  {name: 'Richardson County', fips: '31147'},
  {name: 'Rock County', fips: '31149'},
  {name: 'Saline County', fips: '31151'},
  {name: 'Sarpy County', fips: '31153'},
  {name: 'Saunders County', fips: '31155'},
  {name: 'Scotts Bluff County', fips: '31157'},
  {name: 'Seward County', fips: '31159'},
  {name: 'Sheridan County', fips: '31161'},
  {name: 'Sherman County', fips: '31163'},
  {name: 'Sioux County', fips: '31165'},
  {name: 'Stanton County', fips: '31167'},
  {name: 'Thayer County', fips: '31169'},
  {name: 'Thomas County', fips: '31171'},
  {name: 'Thurston County', fips: '31173'},
  {name: 'Valley County', fips: '31175'},
  {name: 'Washington County', fips: '31177'},
  {name: 'Wayne County', fips: '31179'},
  {name: 'Webster County', fips: '31181'},
  {name: 'Wheeler County', fips: '31183'},
  {name: 'York County', fips: '31185'},

  // Nevada (32)
  {name: 'Churchill County', fips: '32001'},
  {name: 'Clark County', fips: '32003'},
  {name: 'Douglas County', fips: '32005'},
  {name: 'Elko County', fips: '32007'},
  {name: 'Esmeralda County', fips: '32009'},
  {name: 'Eureka County', fips: '32011'},
  {name: 'Humboldt County', fips: '32013'},
  {name: 'Lander County', fips: '32015'},
  {name: 'Lincoln County', fips: '32017'},
  {name: 'Lyon County', fips: '32019'},
  {name: 'Mineral County', fips: '32021'},
  {name: 'Nye County', fips: '32023'},
  {name: 'Pershing County', fips: '32027'},
  {name: 'Storey County', fips: '32029'},
  {name: 'Washoe County', fips: '32031'},
  {name: 'White Pine County', fips: '32033'},
  {name: 'Carson City', fips: '32510'},

  // New Hampshire (33)
  {name: 'Belknap County', fips: '33001'},
  {name: 'Carroll County', fips: '33003'},
  {name: 'Cheshire County', fips: '33005'},
  {name: 'Coos County', fips: '33007'},
  {name: 'Grafton County', fips: '33009'},
  {name: 'Hillsborough County', fips: '33011'},
  {name: 'Merrimack County', fips: '33013'},
  {name: 'Rockingham County', fips: '33015'},
  {name: 'Strafford County', fips: '33017'},
  {name: 'Sullivan County', fips: '33019'},

  // New Jersey (34)
  {name: 'Atlantic County', fips: '34001'},
  {name: 'Bergen County', fips: '34003'},
  {name: 'Burlington County', fips: '34005'},
  {name: 'Camden County', fips: '34007'},
  {name: 'Cape May County', fips: '34009'},
  {name: 'Cumberland County', fips: '34011'},
  {name: 'Essex County', fips: '34013'},
  {name: 'Gloucester County', fips: '34015'},
  {name: 'Hudson County', fips: '34017'},
  {name: 'Hunterdon County', fips: '34019'},
  {name: 'Mercer County', fips: '34021'},
  {name: 'Middlesex County', fips: '34023'},
  {name: 'Monmouth County', fips: '34025'},
  {name: 'Morris County', fips: '34027'},
  {name: 'Ocean County', fips: '34029'},
  {name: 'Passaic County', fips: '34031'},
  {name: 'Salem County', fips: '34033'},
  {name: 'Somerset County', fips: '34035'},
  {name: 'Sussex County', fips: '34037'},
  {name: 'Union County', fips: '34039'},
  {name: 'Warren County', fips: '34041'},

  // New Mexico (35)
  {name: 'Bernalillo County', fips: '35001'},
  {name: 'Catron County', fips: '35003'},
  {name: 'Chaves County', fips: '35005'},
  {name: 'Cibola County', fips: '35006'},
  {name: 'Colfax County', fips: '35007'},
  {name: 'Curry County', fips: '35009'},
  {name: 'De Baca County', fips: '35011'},
  {name: 'Dona Ana County', fips: '35013'},
  {name: 'Eddy County', fips: '35015'},
  {name: 'Grant County', fips: '35017'},
  {name: 'Guadalupe County', fips: '35019'},
  {name: 'Harding County', fips: '35021'},
  {name: 'Hidalgo County', fips: '35023'},
  {name: 'Lea County', fips: '35025'},
  {name: 'Lincoln County', fips: '35027'},
  {name: 'Los Alamos County', fips: '35028'},
  {name: 'Luna County', fips: '35029'},
  {name: 'McKinley County', fips: '35031'},
  {name: 'Mora County', fips: '35033'},
  {name: 'Otero County', fips: '35035'},
  {name: 'Quay County', fips: '35037'},
  {name: 'Rio Arriba County', fips: '35039'},
  {name: 'Roosevelt County', fips: '35041'},
  {name: 'Sandoval County', fips: '35043'},
  {name: 'San Juan County', fips: '35045'},
  {name: 'San Miguel County', fips: '35047'},
  {name: 'Santa Fe County', fips: '35049'},
  {name: 'Sierra County', fips: '35051'},
  {name: 'Socorro County', fips: '35053'},
  {name: 'Taos County', fips: '35055'},
  {name: 'Torrance County', fips: '35057'},
  {name: 'Union County', fips: '35059'},
  {name: 'Valencia County', fips: '35061'},

  // New York (36)
  {name: 'Albany County', fips: '36001'},
  {name: 'Allegany County', fips: '36003'},
  {name: 'Bronx County', fips: '36005'},
  {name: 'Broome County', fips: '36007'},
  {name: 'Cattaraugus County', fips: '36009'},
  {name: 'Cayuga County', fips: '36011'},
  {name: 'Chautauqua County', fips: '36013'},
  {name: 'Chemung County', fips: '36015'},
  {name: 'Chenango County', fips: '36017'},
  {name: 'Clinton County', fips: '36019'},
  {name: 'Columbia County', fips: '36021'},
  {name: 'Cortland County', fips: '36023'},
  {name: 'Delaware County', fips: '36025'},
  {name: 'Dutchess County', fips: '36027'},
  {name: 'Erie County', fips: '36029'},
  {name: 'Essex County', fips: '36031'},
  {name: 'Franklin County', fips: '36033'},
  {name: 'Fulton County', fips: '36035'},
  {name: 'Genesee County', fips: '36037'},
  {name: 'Greene County', fips: '36039'},
  {name: 'Hamilton County', fips: '36041'},
  {name: 'Herkimer County', fips: '36043'},
  {name: 'Jefferson County', fips: '36045'},
  {name: 'Kings County', fips: '36047'},
  {name: 'Lewis County', fips: '36049'},
  {name: 'Livingston County', fips: '36051'},
  {name: 'Madison County', fips: '36053'},
  {name: 'Monroe County', fips: '36055'},
  {name: 'Montgomery County', fips: '36057'},
  {name: 'Nassau County', fips: '36059'},
  {name: 'New York County', fips: '36061'},
  {name: 'Niagara County', fips: '36063'},
  {name: 'Oneida County', fips: '36065'},
  {name: 'Onondaga County', fips: '36067'},
  {name: 'Ontario County', fips: '36069'},
  {name: 'Orange County', fips: '36071'},
  {name: 'Orleans County', fips: '36073'},
  {name: 'Oswego County', fips: '36075'},
  {name: 'Otsego County', fips: '36077'},
  {name: 'Putnam County', fips: '36079'},
  {name: 'Queens County', fips: '36081'},
  {name: 'Rensselaer County', fips: '36083'},
  {name: 'Richmond County', fips: '36085'},
  {name: 'Rockland County', fips: '36087'},
  {name: 'St. Lawrence County', fips: '36089'},
  {name: 'Saratoga County', fips: '36091'},
  {name: 'Schenectady County', fips: '36093'},
  {name: 'Schoharie County', fips: '36095'},
  {name: 'Schuyler County', fips: '36097'},
  {name: 'Seneca County', fips: '36099'},
  {name: 'Steuben County', fips: '36101'},
  {name: 'Suffolk County', fips: '36103'},
  {name: 'Sullivan County', fips: '36105'},
  {name: 'Tioga County', fips: '36107'},
  {name: 'Tompkins County', fips: '36109'},
  {name: 'Ulster County', fips: '36111'},
  {name: 'Warren County', fips: '36113'},
  {name: 'Washington County', fips: '36115'},
  {name: 'Wayne County', fips: '36117'},
  {name: 'Westchester County', fips: '36119'},
  {name: 'Wyoming County', fips: '36121'},
  {name: 'Yates County', fips: '36123'},

  // North Carolina (37)
  {name: 'Alamance County', fips: '37001'},
  {name: 'Alexander County', fips: '37003'},
  {name: 'Alleghany County', fips: '37005'},
  {name: 'Anson County', fips: '37007'},
  {name: 'Ashe County', fips: '37009'},
  {name: 'Avery County', fips: '37011'},
  {name: 'Beaufort County', fips: '37013'},
  {name: 'Bertie County', fips: '37015'},
  {name: 'Bladen County', fips: '37017'},
  {name: 'Brunswick County', fips: '37019'},
  {name: 'Buncombe County', fips: '37021'},
  {name: 'Burke County', fips: '37023'},
  {name: 'Cabarrus County', fips: '37025'},
  {name: 'Caldwell County', fips: '37027'},
  {name: 'Camden County', fips: '37029'},
  {name: 'Carteret County', fips: '37031'},
  {name: 'Caswell County', fips: '37033'},
  {name: 'Catawba County', fips: '37035'},
  {name: 'Chatham County', fips: '37037'},
  {name: 'Cherokee County', fips: '37039'},
  {name: 'Chowan County', fips: '37041'},
  {name: 'Clay County', fips: '37043'},
  {name: 'Cleveland County', fips: '37045'},
  {name: 'Columbus County', fips: '37047'},
  {name: 'Craven County', fips: '37049'},
  {name: 'Cumberland County', fips: '37051'},
  {name: 'Currituck County', fips: '37053'},
  {name: 'Dare County', fips: '37055'},
  {name: 'Davidson County', fips: '37057'},
  {name: 'Davie County', fips: '37059'},
  {name: 'Duplin County', fips: '37061'},
  {name: 'Durham County', fips: '37063'},
  {name: 'Edgecombe County', fips: '37065'},
  {name: 'Forsyth County', fips: '37067'},
  {name: 'Franklin County', fips: '37069'},
  {name: 'Gaston County', fips: '37071'},
  {name: 'Gates County', fips: '37073'},
  {name: 'Graham County', fips: '37075'},
  {name: 'Granville County', fips: '37077'},
  {name: 'Greene County', fips: '37079'},
  {name: 'Guilford County', fips: '37081'},
  {name: 'Halifax County', fips: '37083'},
  {name: 'Harnett County', fips: '37085'},
  {name: 'Haywood County', fips: '37087'},
  {name: 'Henderson County', fips: '37089'},
  {name: 'Hertford County', fips: '37091'},
  {name: 'Hoke County', fips: '37093'},
  {name: 'Hyde County', fips: '37095'},
  {name: 'Iredell County', fips: '37097'},
  {name: 'Jackson County', fips: '37099'},
  {name: 'Johnston County', fips: '37101'},
  {name: 'Jones County', fips: '37103'},
  {name: 'Lee County', fips: '37105'},
  {name: 'Lenoir County', fips: '37107'},
  {name: 'Lincoln County', fips: '37109'},
  {name: 'McDowell County', fips: '37111'},
  {name: 'Macon County', fips: '37113'},
  {name: 'Madison County', fips: '37115'},
  {name: 'Martin County', fips: '37117'},
  {name: 'Mecklenburg County', fips: '37119'},
  {name: 'Mitchell County', fips: '37121'},
  {name: 'Montgomery County', fips: '37123'},
  {name: 'Moore County', fips: '37125'},
  {name: 'Nash County', fips: '37127'},
  {name: 'New Hanover County', fips: '37129'},
  {name: 'Northampton County', fips: '37131'},
  {name: 'Onslow County', fips: '37133'},
  {name: 'Orange County', fips: '37135'},
  {name: 'Pamlico County', fips: '37137'},
  {name: 'Pasquotank County', fips: '37139'},
  {name: 'Pender County', fips: '37141'},
  {name: 'Perquimans County', fips: '37143'},
  {name: 'Person County', fips: '37145'},
  {name: 'Pitt County', fips: '37147'},
  {name: 'Polk County', fips: '37149'},
  {name: 'Randolph County', fips: '37151'},
  {name: 'Richmond County', fips: '37153'},
  {name: 'Robeson County', fips: '37155'},
  {name: 'Rockingham County', fips: '37157'},
  {name: 'Rowan County', fips: '37159'},
  {name: 'Rutherford County', fips: '37161'},
  {name: 'Sampson County', fips: '37163'},
  {name: 'Scotland County', fips: '37165'},
  {name: 'Stanly County', fips: '37167'},
  {name: 'Stokes County', fips: '37169'},
  {name: 'Surry County', fips: '37171'},
  {name: 'Swain County', fips: '37173'},
  {name: 'Transylvania County', fips: '37175'},
  {name: 'Tyrrell County', fips: '37177'},
  {name: 'Union County', fips: '37179'},
  {name: 'Vance County', fips: '37181'},
  {name: 'Wake County', fips: '37183'},
  {name: 'Warren County', fips: '37185'},
  {name: 'Washington County', fips: '37187'},
  {name: 'Watauga County', fips: '37189'},
  {name: 'Wayne County', fips: '37191'},
  {name: 'Wilkes County', fips: '37193'},
  {name: 'Wilson County', fips: '37195'},
  {name: 'Yadkin County', fips: '37197'},
  {name: 'Yancey County', fips: '37199'},

  // North Dakota (38)
  {name: 'Adams County', fips: '38001'},
  {name: 'Barnes County', fips: '38003'},
  {name: 'Benson County', fips: '38005'},
  {name: 'Billings County', fips: '38007'},
  {name: 'Bottineau County', fips: '38009'},
  {name: 'Bowman County', fips: '38011'},
  {name: 'Burke County', fips: '38013'},
  {name: 'Burleigh County', fips: '38015'},
  {name: 'Cass County', fips: '38017'},
  {name: 'Cavalier County', fips: '38019'},
  {name: 'Dickey County', fips: '38021'},
  {name: 'Divide County', fips: '38023'},
  {name: 'Dunn County', fips: '38025'},
  {name: 'Eddy County', fips: '38027'},
  {name: 'Emmons County', fips: '38029'},
  {name: 'Foster County', fips: '38031'},
  {name: 'Golden Valley County', fips: '38033'},
  {name: 'Grand Forks County', fips: '38035'},
  {name: 'Grant County', fips: '38037'},
  {name: 'Griggs County', fips: '38039'},
  {name: 'Hettinger County', fips: '38041'},
  {name: 'Kidder County', fips: '38043'},
  {name: 'LaMoure County', fips: '38045'},
  {name: 'Logan County', fips: '38047'},
  {name: 'McHenry County', fips: '38049'},
  {name: 'McIntosh County', fips: '38051'},
  {name: 'McKenzie County', fips: '38053'},
  {name: 'McLean County', fips: '38055'},
  {name: 'Mercer County', fips: '38057'},
  {name: 'Morton County', fips: '38059'},
  {name: 'Mountrail County', fips: '38061'},
  {name: 'Nelson County', fips: '38063'},
  {name: 'Oliver County', fips: '38065'},
  {name: 'Pembina County', fips: '38067'},
  {name: 'Pierce County', fips: '38069'},
  {name: 'Ramsey County', fips: '38071'},
  {name: 'Ransom County', fips: '38073'},
  {name: 'Renville County', fips: '38075'},
  {name: 'Richland County', fips: '38077'},
  {name: 'Rolette County', fips: '38079'},
  {name: 'Sargent County', fips: '38081'},
  {name: 'Sheridan County', fips: '38083'},
  {name: 'Sioux County', fips: '38085'},
  {name: 'Slope County', fips: '38087'},
  {name: 'Stark County', fips: '38089'},
  {name: 'Steele County', fips: '38091'},
  {name: 'Stutsman County', fips: '38093'},
  {name: 'Towner County', fips: '38095'},
  {name: 'Traill County', fips: '38097'},
  {name: 'Walsh County', fips: '38099'},
  {name: 'Ward County', fips: '38101'},
  {name: 'Wells County', fips: '38103'},
  {name: 'Williams County', fips: '38105'},

  // Ohio (39)
  {name: 'Adams County', fips: '39001'},
  {name: 'Allen County', fips: '39003'},
  {name: 'Ashland County', fips: '39005'},
  {name: 'Ashtabula County', fips: '39007'},
  {name: 'Athens County', fips: '39009'},
  {name: 'Auglaize County', fips: '39011'},
  {name: 'Belmont County', fips: '39013'},
  {name: 'Brown County', fips: '39015'},
  {name: 'Butler County', fips: '39017'},
  {name: 'Carroll County', fips: '39019'},
  {name: 'Champaign County', fips: '39021'},
  {name: 'Clark County', fips: '39023'},
  {name: 'Clermont County', fips: '39025'},
  {name: 'Clinton County', fips: '39027'},
  {name: 'Columbiana County', fips: '39029'},
  {name: 'Coshocton County', fips: '39031'},
  {name: 'Crawford County', fips: '39033'},
  {name: 'Cuyahoga County', fips: '39035'},
  {name: 'Darke County', fips: '39037'},
  {name: 'Defiance County', fips: '39039'},
  {name: 'Delaware County', fips: '39041'},
  {name: 'Erie County', fips: '39043'},
  {name: 'Fairfield County', fips: '39045'},
  {name: 'Fayette County', fips: '39047'},
  {name: 'Franklin County', fips: '39049'},
  {name: 'Fulton County', fips: '39051'},
  {name: 'Gallia County', fips: '39053'},
  {name: 'Geauga County', fips: '39055'},
  {name: 'Greene County', fips: '39057'},
  {name: 'Guernsey County', fips: '39059'},
  {name: 'Hamilton County', fips: '39061'},
  {name: 'Hancock County', fips: '39063'},
  {name: 'Hardin County', fips: '39065'},
  {name: 'Harrison County', fips: '39067'},
  {name: 'Henry County', fips: '39069'},
  {name: 'Highland County', fips: '39071'},
  {name: 'Hocking County', fips: '39073'},
  {name: 'Holmes County', fips: '39075'},
  {name: 'Huron County', fips: '39077'},
  {name: 'Jackson County', fips: '39079'},
  {name: 'Jefferson County', fips: '39081'},
  {name: 'Knox County', fips: '39083'},
  {name: 'Lake County', fips: '39085'},
  {name: 'Lawrence County', fips: '39087'},
  {name: 'Licking County', fips: '39089'},
  {name: 'Logan County', fips: '39091'},
  {name: 'Lorain County', fips: '39093'},
  {name: 'Lucas County', fips: '39095'},
  {name: 'Madison County', fips: '39097'},
  {name: 'Mahoning County', fips: '39099'},
  {name: 'Marion County', fips: '39101'},
  {name: 'Medina County', fips: '39103'},
  {name: 'Meigs County', fips: '39105'},
  {name: 'Mercer County', fips: '39107'},
  {name: 'Miami County', fips: '39109'},
  {name: 'Monroe County', fips: '39111'},
  {name: 'Montgomery County', fips: '39113'},
  {name: 'Morgan County', fips: '39115'},
  {name: 'Morrow County', fips: '39117'},
  {name: 'Muskingum County', fips: '39119'},
  {name: 'Noble County', fips: '39121'},
  {name: 'Ottawa County', fips: '39123'},
  {name: 'Paulding County', fips: '39125'},
  {name: 'Perry County', fips: '39127'},
  {name: 'Pickaway County', fips: '39129'},
  {name: 'Pike County', fips: '39131'},
  {name: 'Portage County', fips: '39133'},
  {name: 'Preble County', fips: '39135'},
  {name: 'Putnam County', fips: '39137'},
  {name: 'Richland County', fips: '39139'},
  {name: 'Ross County', fips: '39141'},
  {name: 'Sandusky County', fips: '39143'},
  {name: 'Scioto County', fips: '39145'},
  {name: 'Seneca County', fips: '39147'},
  {name: 'Shelby County', fips: '39149'},
  {name: 'Stark County', fips: '39151'},
  {name: 'Summit County', fips: '39153'},
  {name: 'Trumbull County', fips: '39155'},
  {name: 'Tuscarawas County', fips: '39157'},
  {name: 'Union County', fips: '39159'},
  {name: 'Van Wert County', fips: '39161'},
  {name: 'Vinton County', fips: '39163'},
  {name: 'Warren County', fips: '39165'},
  {name: 'Washington County', fips: '39167'},
  {name: 'Wayne County', fips: '39169'},
  {name: 'Williams County', fips: '39171'},
  {name: 'Wood County', fips: '39173'},
  {name: 'Wyandot County', fips: '39175'},

  // Oklahoma (40)
  {name: 'Adair County', fips: '40001'},
  {name: 'Alfalfa County', fips: '40003'},
  {name: 'Atoka County', fips: '40005'},
  {name: 'Beaver County', fips: '40007'},
  {name: 'Beckham County', fips: '40009'},
  {name: 'Blaine County', fips: '40011'},
  {name: 'Bryan County', fips: '40013'},
  {name: 'Caddo County', fips: '40015'},
  {name: 'Canadian County', fips: '40017'},
  {name: 'Carter County', fips: '40019'},
  {name: 'Cherokee County', fips: '40021'},
  {name: 'Choctaw County', fips: '40023'},
  {name: 'Cimarron County', fips: '40025'},
  {name: 'Cleveland County', fips: '40027'},
  {name: 'Coal County', fips: '40029'},
  {name: 'Comanche County', fips: '40031'},
  {name: 'Cotton County', fips: '40033'},
  {name: 'Craig County', fips: '40035'},
  {name: 'Creek County', fips: '40037'},
  {name: 'Custer County', fips: '40039'},
  {name: 'Delaware County', fips: '40041'},
  {name: 'Dewey County', fips: '40043'},
  {name: 'Ellis County', fips: '40045'},
  {name: 'Garfield County', fips: '40047'},
  {name: 'Garvin County', fips: '40049'},
  {name: 'Grady County', fips: '40051'},
  {name: 'Grant County', fips: '40053'},
  {name: 'Greer County', fips: '40055'},
  {name: 'Harmon County', fips: '40057'},
  {name: 'Harper County', fips: '40059'},
  {name: 'Haskell County', fips: '40061'},
  {name: 'Hughes County', fips: '40063'},
  {name: 'Jackson County', fips: '40065'},
  {name: 'Jefferson County', fips: '40067'},
  {name: 'Johnston County', fips: '40069'},
  {name: 'Kay County', fips: '40071'},
  {name: 'Kingfisher County', fips: '40073'},
  {name: 'Kiowa County', fips: '40075'},
  {name: 'Latimer County', fips: '40077'},
  {name: 'Le Flore County', fips: '40079'},
  {name: 'Lincoln County', fips: '40081'},
  {name: 'Logan County', fips: '40083'},
  {name: 'Love County', fips: '40085'},
  {name: 'McClain County', fips: '40087'},
  {name: 'McCurtain County', fips: '40089'},
  {name: 'McIntosh County', fips: '40091'},
  {name: 'Major County', fips: '40093'},
  {name: 'Marshall County', fips: '40095'},
  {name: 'Mayes County', fips: '40097'},
  {name: 'Murray County', fips: '40099'},
  {name: 'Muskogee County', fips: '40101'},
  {name: 'Noble County', fips: '40103'},
  {name: 'Nowata County', fips: '40105'},
  {name: 'Okfuskee County', fips: '40107'},
  {name: 'Oklahoma County', fips: '40109'},
  {name: 'Okmulgee County', fips: '40111'},
  {name: 'Osage County', fips: '40113'},
  {name: 'Ottawa County', fips: '40115'},
  {name: 'Pawnee County', fips: '40117'},
  {name: 'Payne County', fips: '40119'},
  {name: 'Pittsburg County', fips: '40121'},
  {name: 'Pontotoc County', fips: '40123'},
  {name: 'Pottawatomie County', fips: '40125'},
  {name: 'Pushmataha County', fips: '40127'},
  {name: 'Roger Mills County', fips: '40129'},
  {name: 'Rogers County', fips: '40131'},
  {name: 'Seminole County', fips: '40133'},
  {name: 'Sequoyah County', fips: '40135'},
  {name: 'Stephens County', fips: '40137'},
  {name: 'Texas County', fips: '40139'},
  {name: 'Tillman County', fips: '40141'},
  {name: 'Tulsa County', fips: '40143'},
  {name: 'Wagoner County', fips: '40145'},
  {name: 'Washington County', fips: '40147'},
  {name: 'Washita County', fips: '40149'},
  {name: 'Woods County', fips: '40151'},
  {name: 'Woodward County', fips: '40153'},

  // Oregon (41)
  {name: 'Baker County', fips: '41001'},
  {name: 'Benton County', fips: '41003'},
  {name: 'Clackamas County', fips: '41005'},
  {name: 'Clatsop County', fips: '41007'},
  {name: 'Columbia County', fips: '41009'},
  {name: 'Coos County', fips: '41011'},
  {name: 'Crook County', fips: '41013'},
  {name: 'Curry County', fips: '41015'},
  {name: 'Deschutes County', fips: '41017'},
  {name: 'Douglas County', fips: '41019'},
  {name: 'Gilliam County', fips: '41021'},
  {name: 'Grant County', fips: '41023'},
  {name: 'Harney County', fips: '41025'},
  {name: 'Hood River County', fips: '41027'},
  {name: 'Jackson County', fips: '41029'},
  {name: 'Jefferson County', fips: '41031'},
  {name: 'Josephine County', fips: '41033'},
  {name: 'Klamath County', fips: '41035'},
  {name: 'Lake County', fips: '41037'},
  {name: 'Lane County', fips: '41039'},
  {name: 'Lincoln County', fips: '41041'},
  {name: 'Linn County', fips: '41043'},
  {name: 'Malheur County', fips: '41045'},
  {name: 'Marion County', fips: '41047'},
  {name: 'Morrow County', fips: '41049'},
  {name: 'Multnomah County', fips: '41051'},
  {name: 'Polk County', fips: '41053'},
  {name: 'Sherman County', fips: '41055'},
  {name: 'Tillamook County', fips: '41057'},
  {name: 'Umatilla County', fips: '41059'},
  {name: 'Union County', fips: '41061'},
  {name: 'Wallowa County', fips: '41063'},
  {name: 'Wasco County', fips: '41065'},
  {name: 'Washington County', fips: '41067'},
  {name: 'Wheeler County', fips: '41069'},
  {name: 'Yamhill County', fips: '41071'},

  // Pennsylvania (42)
  {name: 'Adams County', fips: '42001'},
  {name: 'Allegheny County', fips: '42003'},
  {name: 'Armstrong County', fips: '42005'},
  {name: 'Beaver County', fips: '42007'},
  {name: 'Bedford County', fips: '42009'},
  {name: 'Berks County', fips: '42011'},
  {name: 'Blair County', fips: '42013'},
  {name: 'Bradford County', fips: '42015'},
  {name: 'Bucks County', fips: '42017'},
  {name: 'Butler County', fips: '42019'},
  {name: 'Cambria County', fips: '42021'},
  {name: 'Cameron County', fips: '42023'},
  {name: 'Carbon County', fips: '42025'},
  {name: 'Centre County', fips: '42027'},
  {name: 'Chester County', fips: '42029'},
  {name: 'Clarion County', fips: '42031'},
  {name: 'Clearfield County', fips: '42033'},
  {name: 'Clinton County', fips: '42035'},
  {name: 'Columbia County', fips: '42037'},
  {name: 'Crawford County', fips: '42039'},
  {name: 'Cumberland County', fips: '42041'},
  {name: 'Dauphin County', fips: '42043'},
  {name: 'Delaware County', fips: '42045'},
  {name: 'Elk County', fips: '42047'},
  {name: 'Erie County', fips: '42049'},
  {name: 'Fayette County', fips: '42051'},
  {name: 'Forest County', fips: '42053'},
  {name: 'Franklin County', fips: '42055'},
  {name: 'Fulton County', fips: '42057'},
  {name: 'Greene County', fips: '42059'},
  {name: 'Huntingdon County', fips: '42061'},
  {name: 'Indiana County', fips: '42063'},
  {name: 'Jefferson County', fips: '42065'},
  {name: 'Juniata County', fips: '42067'},
  {name: 'Lackawanna County', fips: '42069'},
  {name: 'Lancaster County', fips: '42071'},
  {name: 'Lawrence County', fips: '42073'},
  {name: 'Lebanon County', fips: '42075'},
  {name: 'Lehigh County', fips: '42077'},
  {name: 'Luzerne County', fips: '42079'},
  {name: 'Lycoming County', fips: '42081'},
  {name: 'McKean County', fips: '42083'},
  {name: 'Mercer County', fips: '42085'},
  {name: 'Mifflin County', fips: '42087'},
  {name: 'Monroe County', fips: '42089'},
  {name: 'Montgomery County', fips: '42091'},
  {name: 'Montour County', fips: '42093'},
  {name: 'Northampton County', fips: '42095'},
  {name: 'Northumberland County', fips: '42097'},
  {name: 'Perry County', fips: '42099'},
  {name: 'Philadelphia County', fips: '42101'},
  {name: 'Pike County', fips: '42103'},
  {name: 'Potter County', fips: '42105'},
  {name: 'Schuylkill County', fips: '42107'},
  {name: 'Snyder County', fips: '42109'},
  {name: 'Somerset County', fips: '42111'},
  {name: 'Sullivan County', fips: '42113'},
  {name: 'Susquehanna County', fips: '42115'},
  {name: 'Tioga County', fips: '42117'},
  {name: 'Union County', fips: '42119'},
  {name: 'Venango County', fips: '42121'},
  {name: 'Warren County', fips: '42123'},
  {name: 'Washington County', fips: '42125'},
  {name: 'Wayne County', fips: '42127'},
  {name: 'Westmoreland County', fips: '42129'},
  {name: 'Wyoming County', fips: '42131'},
  {name: 'York County', fips: '42133'},

  // Rhode Island (44)
  {name: 'Bristol County', fips: '44001'},
  {name: 'Kent County', fips: '44003'},
  {name: 'Newport County', fips: '44005'},
  {name: 'Providence County', fips: '44007'},
  {name: 'Washington County', fips: '44009'},

  // South Carolina (45)
  {name: 'Abbeville County', fips: '45001'},
  {name: 'Aiken County', fips: '45003'},
  {name: 'Allendale County', fips: '45005'},
  {name: 'Anderson County', fips: '45007'},
  {name: 'Bamberg County', fips: '45009'},
  {name: 'Barnwell County', fips: '45011'},
  {name: 'Beaufort County', fips: '45013'},
  {name: 'Berkeley County', fips: '45015'},
  {name: 'Calhoun County', fips: '45017'},
  {name: 'Charleston County', fips: '45019'},
  {name: 'Cherokee County', fips: '45021'},
  {name: 'Chester County', fips: '45023'},
  {name: 'Chesterfield County', fips: '45025'},
  {name: 'Clarendon County', fips: '45027'},
  {name: 'Colleton County', fips: '45029'},
  {name: 'Darlington County', fips: '45031'},
  {name: 'Dillon County', fips: '45033'},
  {name: 'Dorchester County', fips: '45035'},
  {name: 'Edgefield County', fips: '45037'},
  {name: 'Fairfield County', fips: '45039'},
  {name: 'Florence County', fips: '45041'},
  {name: 'Georgetown County', fips: '45043'},
  {name: 'Greenville County', fips: '45045'},
  {name: 'Greenwood County', fips: '45047'},
  {name: 'Hampton County', fips: '45049'},
  {name: 'Horry County', fips: '45051'},
  {name: 'Jasper County', fips: '45053'},
  {name: 'Kershaw County', fips: '45055'},
  {name: 'Lancaster County', fips: '45057'},
  {name: 'Laurens County', fips: '45059'},
  {name: 'Lee County', fips: '45061'},
  {name: 'Lexington County', fips: '45063'},
  {name: 'McCormick County', fips: '45065'},
  {name: 'Marion County', fips: '45067'},
  {name: 'Marlboro County', fips: '45069'},
  {name: 'Newberry County', fips: '45071'},
  {name: 'Oconee County', fips: '45073'},
  {name: 'Orangeburg County', fips: '45075'},
  {name: 'Pickens County', fips: '45077'},
  {name: 'Richland County', fips: '45079'},
  {name: 'Saluda County', fips: '45081'},
  {name: 'Spartanburg County', fips: '45083'},
  {name: 'Sumter County', fips: '45085'},
  {name: 'Union County', fips: '45087'},
  {name: 'Williamsburg County', fips: '45089'},
  {name: 'York County', fips: '45091'},

  // South Dakota (46)
  {name: 'Aurora County', fips: '46003'},
  {name: 'Beadle County', fips: '46005'},
  {name: 'Bennett County', fips: '46007'},
  {name: 'Bon Homme County', fips: '46009'},
  {name: 'Brookings County', fips: '46011'},
  {name: 'Brown County', fips: '46013'},
  {name: 'Brule County', fips: '46015'},
  {name: 'Buffalo County', fips: '46017'},
  {name: 'Butte County', fips: '46019'},
  {name: 'Campbell County', fips: '46021'},
  {name: 'Charles Mix County', fips: '46023'},
  {name: 'Clark County', fips: '46025'},
  {name: 'Clay County', fips: '46027'},
  {name: 'Codington County', fips: '46029'},
  {name: 'Corson County', fips: '46031'},
  {name: 'Custer County', fips: '46033'},
  {name: 'Davison County', fips: '46035'},
  {name: 'Day County', fips: '46037'},
  {name: 'Deuel County', fips: '46039'},
  {name: 'Dewey County', fips: '46041'},
  {name: 'Douglas County', fips: '46043'},
  {name: 'Edmunds County', fips: '46045'},
  {name: 'Fall River County', fips: '46047'},
  {name: 'Faulk County', fips: '46049'},
  {name: 'Grant County', fips: '46051'},
  {name: 'Gregory County', fips: '46053'},
  {name: 'Haakon County', fips: '46055'},
  {name: 'Hamlin County', fips: '46057'},
  {name: 'Hand County', fips: '46059'},
  {name: 'Hanson County', fips: '46061'},
  {name: 'Harding County', fips: '46063'},
  {name: 'Hughes County', fips: '46065'},
  {name: 'Hutchinson County', fips: '46067'},
  {name: 'Hyde County', fips: '46069'},
  {name: 'Jackson County', fips: '46071'},
  {name: 'Jerauld County', fips: '46073'},
  {name: 'Jones County', fips: '46075'},
  {name: 'Kingsbury County', fips: '46077'},
  {name: 'Lake County', fips: '46079'},
  {name: 'Lawrence County', fips: '46081'},
  {name: 'Lincoln County', fips: '46083'},
  {name: 'Lyman County', fips: '46085'},
  {name: 'McCook County', fips: '46087'},
  {name: 'McPherson County', fips: '46089'},
  {name: 'Marshall County', fips: '46091'},
  {name: 'Meade County', fips: '46093'},
  {name: 'Mellette County', fips: '46095'},
  {name: 'Miner County', fips: '46097'},
  {name: 'Minnehaha County', fips: '46099'},
  {name: 'Moody County', fips: '46101'},
  {name: 'Oglala Lakota County', fips: '46102'},
  {name: 'Pennington County', fips: '46103'},
  {name: 'Perkins County', fips: '46105'},
  {name: 'Potter County', fips: '46107'},
  {name: 'Roberts County', fips: '46109'},
  {name: 'Sanborn County', fips: '46111'},
  {name: 'Spink County', fips: '46115'},
  {name: 'Stanley County', fips: '46117'},
  {name: 'Sully County', fips: '46119'},
  {name: 'Todd County', fips: '46121'},
  {name: 'Tripp County', fips: '46123'},
  {name: 'Turner County', fips: '46125'},
  {name: 'Union County', fips: '46127'},
  {name: 'Walworth County', fips: '46129'},
  {name: 'Yankton County', fips: '46135'},
  {name: 'Ziebach County', fips: '46137'},

  // Tennessee (47)
  {name: 'Anderson County', fips: '47001'},
  {name: 'Bedford County', fips: '47003'},
  {name: 'Benton County', fips: '47005'},
  {name: 'Bledsoe County', fips: '47007'},
  {name: 'Blount County', fips: '47009'},
  {name: 'Bradley County', fips: '47011'},
  {name: 'Campbell County', fips: '47013'},
  {name: 'Cannon County', fips: '47015'},
  {name: 'Carroll County', fips: '47017'},
  {name: 'Carter County', fips: '47019'},
  {name: 'Cheatham County', fips: '47021'},
  {name: 'Chester County', fips: '47023'},
  {name: 'Claiborne County', fips: '47025'},
  {name: 'Clay County', fips: '47027'},
  {name: 'Cocke County', fips: '47029'},
  {name: 'Coffee County', fips: '47031'},
  {name: 'Crockett County', fips: '47033'},
  {name: 'Cumberland County', fips: '47035'},
  {name: 'Davidson County', fips: '47037'},
  {name: 'Decatur County', fips: '47039'},
  {name: 'DeKalb County', fips: '47041'},
  {name: 'Dickson County', fips: '47043'},
  {name: 'Dyer County', fips: '47045'},
  {name: 'Fayette County', fips: '47047'},
  {name: 'Fentress County', fips: '47049'},
  {name: 'Franklin County', fips: '47051'},
  {name: 'Gibson County', fips: '47053'},
  {name: 'Giles County', fips: '47055'},
  {name: 'Grainger County', fips: '47057'},
  {name: 'Greene County', fips: '47059'},
  {name: 'Grundy County', fips: '47061'},
  {name: 'Hamblen County', fips: '47063'},
  {name: 'Hamilton County', fips: '47065'},
  {name: 'Hancock County', fips: '47067'},
  {name: 'Hardeman County', fips: '47069'},
  {name: 'Hardin County', fips: '47071'},
  {name: 'Hawkins County', fips: '47073'},
  {name: 'Haywood County', fips: '47075'},
  {name: 'Henderson County', fips: '47077'},
  {name: 'Henry County', fips: '47079'},
  {name: 'Hickman County', fips: '47081'},
  {name: 'Houston County', fips: '47083'},
  {name: 'Humphreys County', fips: '47085'},
  {name: 'Jackson County', fips: '47087'},
  {name: 'Jefferson County', fips: '47089'},
  {name: 'Johnson County', fips: '47091'},
  {name: 'Knox County', fips: '47093'},
  {name: 'Lake County', fips: '47095'},
  {name: 'Lauderdale County', fips: '47097'},
  {name: 'Lawrence County', fips: '47099'},
  {name: 'Lewis County', fips: '47101'},
  {name: 'Lincoln County', fips: '47103'},
  {name: 'Loudon County', fips: '47105'},
  {name: 'McMinn County', fips: '47107'},
  {name: 'McNairy County', fips: '47109'},
  {name: 'Macon County', fips: '47111'},
  {name: 'Madison County', fips: '47113'},
  {name: 'Marion County', fips: '47115'},
  {name: 'Marshall County', fips: '47117'},
  {name: 'Maury County', fips: '47119'},
  {name: 'Meigs County', fips: '47121'},
  {name: 'Monroe County', fips: '47123'},
  {name: 'Montgomery County', fips: '47125'},
  {name: 'Moore County', fips: '47127'},
  {name: 'Morgan County', fips: '47129'},
  {name: 'Obion County', fips: '47131'},
  {name: 'Overton County', fips: '47133'},
  {name: 'Perry County', fips: '47135'},
  {name: 'Pickett County', fips: '47137'},
  {name: 'Polk County', fips: '47139'},
  {name: 'Putnam County', fips: '47141'},
  {name: 'Rhea County', fips: '47143'},
  {name: 'Roane County', fips: '47145'},
  {name: 'Robertson County', fips: '47147'},
  {name: 'Rutherford County', fips: '47149'},
  {name: 'Scott County', fips: '47151'},
  {name: 'Sequatchie County', fips: '47153'},
  {name: 'Sevier County', fips: '47155'},
  {name: 'Shelby County', fips: '47157'},
  {name: 'Smith County', fips: '47159'},
  {name: 'Stewart County', fips: '47161'},
  {name: 'Sullivan County', fips: '47163'},
  {name: 'Sumner County', fips: '47165'},
  {name: 'Tipton County', fips: '47167'},
  {name: 'Trousdale County', fips: '47169'},
  {name: 'Unicoi County', fips: '47171'},
  {name: 'Union County', fips: '47173'},
  {name: 'Van Buren County', fips: '47175'},
  {name: 'Warren County', fips: '47177'},
  {name: 'Washington County', fips: '47179'},
  {name: 'Wayne County', fips: '47181'},
  {name: 'Weakley County', fips: '47183'},
  {name: 'White County', fips: '47185'},
  {name: 'Williamson County', fips: '47187'},
  {name: 'Wilson County', fips: '47189'},

  // Texas (48)
  {name: 'Anderson County', fips: '48001'},
  {name: 'Andrews County', fips: '48003'},
  {name: 'Angelina County', fips: '48005'},
  {name: 'Aransas County', fips: '48007'},
  {name: 'Archer County', fips: '48009'},
  {name: 'Armstrong County', fips: '48011'},
  {name: 'Atascosa County', fips: '48013'},
  {name: 'Austin County', fips: '48015'},
  {name: 'Bailey County', fips: '48017'},
  {name: 'Bandera County', fips: '48019'},
  {name: 'Bastrop County', fips: '48021'},
  {name: 'Baylor County', fips: '48023'},
  {name: 'Bee County', fips: '48025'},
  {name: 'Bell County', fips: '48027'},
  {name: 'Bexar County', fips: '48029'},
  {name: 'Blanco County', fips: '48031'},
  {name: 'Borden County', fips: '48033'},
  {name: 'Bosque County', fips: '48035'},
  {name: 'Bowie County', fips: '48037'},
  {name: 'Brazoria County', fips: '48039'},
  {name: 'Brazos County', fips: '48041'},
  {name: 'Brewster County', fips: '48043'},
  {name: 'Briscoe County', fips: '48045'},
  {name: 'Brooks County', fips: '48047'},
  {name: 'Brown County', fips: '48049'},
  {name: 'Burleson County', fips: '48051'},
  {name: 'Burnet County', fips: '48053'},
  {name: 'Caldwell County', fips: '48055'},
  {name: 'Calhoun County', fips: '48057'},
  {name: 'Callahan County', fips: '48059'},
  {name: 'Cameron County', fips: '48061'},
  {name: 'Camp County', fips: '48063'},
  {name: 'Carson County', fips: '48065'},
  {name: 'Cass County', fips: '48067'},
  {name: 'Castro County', fips: '48069'},
  {name: 'Chambers County', fips: '48071'},
  {name: 'Cherokee County', fips: '48073'},
  {name: 'Childress County', fips: '48075'},
  {name: 'Clay County', fips: '48077'},
  {name: 'Cochran County', fips: '48079'},
  {name: 'Coke County', fips: '48081'},
  {name: 'Coleman County', fips: '48083'},
  {name: 'Collin County', fips: '48085'},
  {name: 'Collingsworth County', fips: '48087'},
  {name: 'Colorado County', fips: '48089'},
  {name: 'Comal County', fips: '48091'},
  {name: 'Comanche County', fips: '48093'},
  {name: 'Concho County', fips: '48095'},
  {name: 'Cooke County', fips: '48097'},
  {name: 'Coryell County', fips: '48099'},
  {name: 'Cottle County', fips: '48101'},
  {name: 'Crane County', fips: '48103'},
  {name: 'Crockett County', fips: '48105'},
  {name: 'Crosby County', fips: '48107'},
  {name: 'Culberson County', fips: '48109'},
  {name: 'Dallam County', fips: '48111'},
  {name: 'Dallas County', fips: '48113'},
  {name: 'Dawson County', fips: '48115'},
  {name: 'Deaf Smith County', fips: '48117'},
  {name: 'Delta County', fips: '48119'},
  {name: 'Denton County', fips: '48121'},
  {name: 'DeWitt County', fips: '48123'},
  {name: 'Dickens County', fips: '48125'},
  {name: 'Dimmit County', fips: '48127'},
  {name: 'Donley County', fips: '48129'},
  {name: 'Duval County', fips: '48131'},
  {name: 'Eastland County', fips: '48133'},
  {name: 'Ector County', fips: '48135'},
  {name: 'Edwards County', fips: '48137'},
  {name: 'Ellis County', fips: '48139'},
  {name: 'El Paso County', fips: '48141'},
  {name: 'Erath County', fips: '48143'},
  {name: 'Falls County', fips: '48145'},
  {name: 'Fannin County', fips: '48147'},
  {name: 'Fayette County', fips: '48149'},
  {name: 'Fisher County', fips: '48151'},
  {name: 'Floyd County', fips: '48153'},
  {name: 'Foard County', fips: '48155'},
  {name: 'Fort Bend County', fips: '48157'},
  {name: 'Franklin County', fips: '48159'},
  {name: 'Freestone County', fips: '48161'},
  {name: 'Frio County', fips: '48163'},
  {name: 'Gaines County', fips: '48165'},
  {name: 'Galveston County', fips: '48167'},
  {name: 'Garza County', fips: '48169'},
  {name: 'Gillespie County', fips: '48171'},
  {name: 'Glasscock County', fips: '48173'},
  {name: 'Goliad County', fips: '48175'},
  {name: 'Gonzales County', fips: '48177'},
  {name: 'Gray County', fips: '48179'},
  {name: 'Grayson County', fips: '48181'},
  {name: 'Gregg County', fips: '48183'},
  {name: 'Grimes County', fips: '48185'},
  {name: 'Guadalupe County', fips: '48187'},
  {name: 'Hale County', fips: '48189'},
  {name: 'Hall County', fips: '48191'},
  {name: 'Hamilton County', fips: '48193'},
  {name: 'Hansford County', fips: '48195'},
  {name: 'Hardeman County', fips: '48197'},
  {name: 'Hardin County', fips: '48199'},
  {name: 'Harris County', fips: '48201'},
  {name: 'Harrison County', fips: '48203'},
  {name: 'Hartley County', fips: '48205'},
  {name: 'Haskell County', fips: '48207'},
  {name: 'Hays County', fips: '48209'},
  {name: 'Hemphill County', fips: '48211'},
  {name: 'Henderson County', fips: '48213'},
  {name: 'Hidalgo County', fips: '48215'},
  {name: 'Hill County', fips: '48217'},
  {name: 'Hockley County', fips: '48219'},
  {name: 'Hood County', fips: '48221'},
  {name: 'Hopkins County', fips: '48223'},
  {name: 'Houston County', fips: '48225'},
  {name: 'Howard County', fips: '48227'},
  {name: 'Hudspeth County', fips: '48229'},
  {name: 'Hunt County', fips: '48231'},
  {name: 'Hutchinson County', fips: '48233'},
  {name: 'Irion County', fips: '48235'},
  {name: 'Jack County', fips: '48237'},
  {name: 'Jackson County', fips: '48239'},
  {name: 'Jasper County', fips: '48241'},
  {name: 'Jeff Davis County', fips: '48243'},
  {name: 'Jefferson County', fips: '48245'},
  {name: 'Jim Hogg County', fips: '48247'},
  {name: 'Jim Wells County', fips: '48249'},
  {name: 'Johnson County', fips: '48251'},
  {name: 'Jones County', fips: '48253'},
  {name: 'Karnes County', fips: '48255'},
  {name: 'Kaufman County', fips: '48257'},
  {name: 'Kendall County', fips: '48259'},
  {name: 'Kenedy County', fips: '48261'},
  {name: 'Kent County', fips: '48263'},
  {name: 'Kerr County', fips: '48265'},
  {name: 'Kimble County', fips: '48267'},
  {name: 'King County', fips: '48269'},
  {name: 'Kinney County', fips: '48271'},
  {name: 'Kleberg County', fips: '48273'},
  {name: 'Knox County', fips: '48275'},
  {name: 'Lamar County', fips: '48277'},
  {name: 'Lamb County', fips: '48279'},
  {name: 'Lampasas County', fips: '48281'},
  {name: 'La Salle County', fips: '48283'},
  {name: 'Lavaca County', fips: '48285'},
  {name: 'Lee County', fips: '48287'},
  {name: 'Leon County', fips: '48289'},
  {name: 'Liberty County', fips: '48291'},
  {name: 'Limestone County', fips: '48293'},
  {name: 'Lipscomb County', fips: '48295'},
  {name: 'Live Oak County', fips: '48297'},
  {name: 'Llano County', fips: '48299'},
  {name: 'Loving County', fips: '48301'},
  {name: 'Lubbock County', fips: '48303'},
  {name: 'Lynn County', fips: '48305'},
  {name: 'McCulloch County', fips: '48307'},
  {name: 'McLennan County', fips: '48309'},
  {name: 'McMullen County', fips: '48311'},
  {name: 'Madison County', fips: '48313'},
  {name: 'Marion County', fips: '48315'},
  {name: 'Martin County', fips: '48317'},
  {name: 'Mason County', fips: '48319'},
  {name: 'Matagorda County', fips: '48321'},
  {name: 'Maverick County', fips: '48323'},
  {name: 'Medina County', fips: '48325'},
  {name: 'Menard County', fips: '48327'},
  {name: 'Midland County', fips: '48329'},
  {name: 'Milam County', fips: '48331'},
  {name: 'Mills County', fips: '48333'},
  {name: 'Mitchell County', fips: '48335'},
  {name: 'Montague County', fips: '48337'},
  {name: 'Montgomery County', fips: '48339'},
  {name: 'Moore County', fips: '48341'},
  {name: 'Morris County', fips: '48343'},
  {name: 'Motley County', fips: '48345'},
  {name: 'Nacogdoches County', fips: '48347'},
  {name: 'Navarro County', fips: '48349'},
  {name: 'Newton County', fips: '48351'},
  {name: 'Nolan County', fips: '48353'},
  {name: 'Nueces County', fips: '48355'},
  {name: 'Ochiltree County', fips: '48357'},
  {name: 'Oldham County', fips: '48359'},
  {name: 'Orange County', fips: '48361'},
  {name: 'Palo Pinto County', fips: '48363'},
  {name: 'Panola County', fips: '48365'},
  {name: 'Parker County', fips: '48367'},
  {name: 'Parmer County', fips: '48369'},
  {name: 'Pecos County', fips: '48371'},
  {name: 'Polk County', fips: '48373'},
  {name: 'Potter County', fips: '48375'},
  {name: 'Presidio County', fips: '48377'},
  {name: 'Rains County', fips: '48379'},
  {name: 'Randall County', fips: '48381'},
  {name: 'Reagan County', fips: '48383'},
  {name: 'Real County', fips: '48385'},
  {name: 'Red River County', fips: '48387'},
  {name: 'Reeves County', fips: '48389'},
  {name: 'Refugio County', fips: '48391'},
  {name: 'Roberts County', fips: '48393'},
  {name: 'Robertson County', fips: '48395'},
  {name: 'Rockwall County', fips: '48397'},
  {name: 'Runnels County', fips: '48399'},
  {name: 'Rusk County', fips: '48401'},
  {name: 'Sabine County', fips: '48403'},
  {name: 'San Augustine County', fips: '48405'},
  {name: 'San Jacinto County', fips: '48407'},
  {name: 'San Patricio County', fips: '48409'},
  {name: 'San Saba County', fips: '48411'},
  {name: 'Schleicher County', fips: '48413'},
  {name: 'Scurry County', fips: '48415'},
  {name: 'Shackelford County', fips: '48417'},
  {name: 'Shelby County', fips: '48419'},
  {name: 'Sherman County', fips: '48421'},
  {name: 'Smith County', fips: '48423'},
  {name: 'Somervell County', fips: '48425'},
  {name: 'Starr County', fips: '48427'},
  {name: 'Stephens County', fips: '48429'},
  {name: 'Sterling County', fips: '48431'},
  {name: 'Stonewall County', fips: '48433'},
  {name: 'Sutton County', fips: '48435'},
  {name: 'Swisher County', fips: '48437'},
  {name: 'Tarrant County', fips: '48439'},
  {name: 'Taylor County', fips: '48441'},
  {name: 'Terrell County', fips: '48443'},
  {name: 'Terry County', fips: '48445'},
  {name: 'Throckmorton County', fips: '48447'},
  {name: 'Titus County', fips: '48449'},
  {name: 'Tom Green County', fips: '48451'},
  {name: 'Travis County', fips: '48453'},
  {name: 'Trinity County', fips: '48455'},
  {name: 'Tyler County', fips: '48457'},
  {name: 'Upshur County', fips: '48459'},
  {name: 'Upton County', fips: '48461'},
  {name: 'Uvalde County', fips: '48463'},
  {name: 'Val Verde County', fips: '48465'},
  {name: 'Van Zandt County', fips: '48467'},
  {name: 'Victoria County', fips: '48469'},
  {name: 'Walker County', fips: '48471'},
  {name: 'Waller County', fips: '48473'},
  {name: 'Ward County', fips: '48475'},
  {name: 'Washington County', fips: '48477'},
  {name: 'Webb County', fips: '48479'},
  {name: 'Wharton County', fips: '48481'},
  {name: 'Wheeler County', fips: '48483'},
  {name: 'Wichita County', fips: '48485'},
  {name: 'Wilbarger County', fips: '48487'},
  {name: 'Willacy County', fips: '48489'},
  {name: 'Williamson County', fips: '48491'},
  {name: 'Wilson County', fips: '48493'},
  {name: 'Winkler County', fips: '48495'},
  {name: 'Wise County', fips: '48497'},
  {name: 'Wood County', fips: '48499'},
  {name: 'Yoakum County', fips: '48501'},
  {name: 'Young County', fips: '48503'},
  {name: 'Zapata County', fips: '48505'},
  {name: 'Zavala County', fips: '48507'},

  // Utah (49)
  {name: 'Beaver County', fips: '49001'},
  {name: 'Box Elder County', fips: '49003'},
  {name: 'Cache County', fips: '49005'},
  {name: 'Carbon County', fips: '49007'},
  {name: 'Daggett County', fips: '49009'},
  {name: 'Davis County', fips: '49011'},
  {name: 'Duchesne County', fips: '49013'},
  {name: 'Emery County', fips: '49015'},
  {name: 'Garfield County', fips: '49017'},
  {name: 'Grand County', fips: '49019'},
  {name: 'Iron County', fips: '49021'},
  {name: 'Juab County', fips: '49023'},
  {name: 'Kane County', fips: '49025'},
  {name: 'Millard County', fips: '49027'},
  {name: 'Morgan County', fips: '49029'},
  {name: 'Piute County', fips: '49031'},
  {name: 'Rich County', fips: '49033'},
  {name: 'Salt Lake County', fips: '49035'},
  {name: 'San Juan County', fips: '49037'},
  {name: 'Sanpete County', fips: '49039'},
  {name: 'Sevier County', fips: '49041'},
  {name: 'Summit County', fips: '49043'},
  {name: 'Tooele County', fips: '49045'},
  {name: 'Uintah County', fips: '49047'},
  {name: 'Utah County', fips: '49049'},
  {name: 'Wasatch County', fips: '49051'},
  {name: 'Washington County', fips: '49053'},
  {name: 'Wayne County', fips: '49055'},
  {name: 'Weber County', fips: '49057'},

  // Vermont (50)
  {name: 'Addison County', fips: '50001'},
  {name: 'Bennington County', fips: '50003'},
  {name: 'Caledonia County', fips: '50005'},
  {name: 'Chittenden County', fips: '50007'},
  {name: 'Essex County', fips: '50009'},
  {name: 'Franklin County', fips: '50011'},
  {name: 'Grand Isle County', fips: '50013'},
  {name: 'Lamoille County', fips: '50015'},
  {name: 'Orange County', fips: '50017'},
  {name: 'Orleans County', fips: '50019'},
  {name: 'Rutland County', fips: '50021'},
  {name: 'Washington County', fips: '50023'},
  {name: 'Windham County', fips: '50025'},
  {name: 'Windsor County', fips: '50027'},

  // Virginia (51)
  {name: 'Accomack County', fips: '51001'},
  {name: 'Albemarle County', fips: '51003'},
  {name: 'Alleghany County', fips: '51005'},
  {name: 'Amelia County', fips: '51007'},
  {name: 'Amherst County', fips: '51009'},
  {name: 'Appomattox County', fips: '51011'},
  {name: 'Arlington County', fips: '51013'},
  {name: 'Augusta County', fips: '51015'},
  {name: 'Bath County', fips: '51017'},
  {name: 'Bedford County', fips: '51019'},
  {name: 'Bland County', fips: '51021'},
  {name: 'Botetourt County', fips: '51023'},
  {name: 'Brunswick County', fips: '51025'},
  {name: 'Buchanan County', fips: '51027'},
  {name: 'Buckingham County', fips: '51029'},
  {name: 'Campbell County', fips: '51031'},
  {name: 'Caroline County', fips: '51033'},
  {name: 'Carroll County', fips: '51035'},
  {name: 'Charles City County', fips: '51036'},
  {name: 'Charlotte County', fips: '51037'},
  {name: 'Chesterfield County', fips: '51041'},
  {name: 'Clarke County', fips: '51043'},
  {name: 'Craig County', fips: '51045'},
  {name: 'Culpeper County', fips: '51047'},
  {name: 'Cumberland County', fips: '51049'},
  {name: 'Dickenson County', fips: '51051'},
  {name: 'Dinwiddie County', fips: '51053'},
  {name: 'Essex County', fips: '51057'},
  {name: 'Fairfax County', fips: '51059'},
  {name: 'Fauquier County', fips: '51061'},
  {name: 'Floyd County', fips: '51063'},
  {name: 'Fluvanna County', fips: '51065'},
  {name: 'Franklin County', fips: '51067'},
  {name: 'Frederick County', fips: '51069'},
  {name: 'Giles County', fips: '51071'},
  {name: 'Gloucester County', fips: '51073'},
  {name: 'Goochland County', fips: '51075'},
  {name: 'Grayson County', fips: '51077'},
  {name: 'Greene County', fips: '51079'},
  {name: 'Greensville County', fips: '51081'},
  {name: 'Halifax County', fips: '51083'},
  {name: 'Hanover County', fips: '51085'},
  {name: 'Henrico County', fips: '51087'},
  {name: 'Henry County', fips: '51089'},
  {name: 'Highland County', fips: '51091'},
  {name: 'Isle of Wight County', fips: '51093'},
  {name: 'James City County', fips: '51095'},
  {name: 'King and Queen County', fips: '51097'},
  {name: 'King George County', fips: '51099'},
  {name: 'King William County', fips: '51101'},
  {name: 'Lancaster County', fips: '51103'},
  {name: 'Lee County', fips: '51105'},
  {name: 'Loudoun County', fips: '51107'},
  {name: 'Louisa County', fips: '51109'},
  {name: 'Lunenburg County', fips: '51111'},
  {name: 'Madison County', fips: '51113'},
  {name: 'Mathews County', fips: '51115'},
  {name: 'Mecklenburg County', fips: '51117'},
  {name: 'Middlesex County', fips: '51119'},
  {name: 'Montgomery County', fips: '51121'},
  {name: 'Nelson County', fips: '51125'},
  {name: 'New Kent County', fips: '51127'},
  {name: 'Northampton County', fips: '51131'},
  {name: 'Northumberland County', fips: '51133'},
  {name: 'Nottoway County', fips: '51135'},
  {name: 'Orange County', fips: '51137'},
  {name: 'Page County', fips: '51139'},
  {name: 'Patrick County', fips: '51141'},
  {name: 'Pittsylvania County', fips: '51143'},
  {name: 'Powhatan County', fips: '51145'},
  {name: 'Prince Edward County', fips: '51147'},
  {name: 'Prince George County', fips: '51149'},
  {name: 'Prince William County', fips: '51153'},
  {name: 'Pulaski County', fips: '51155'},
  {name: 'Rappahannock County', fips: '51157'},
  {name: 'Richmond County', fips: '51159'},
  {name: 'Roanoke County', fips: '51161'},
  {name: 'Rockbridge County', fips: '51163'},
  {name: 'Rockingham County', fips: '51165'},
  {name: 'Russell County', fips: '51167'},
  {name: 'Scott County', fips: '51169'},
  {name: 'Shenandoah County', fips: '51171'},
  {name: 'Smyth County', fips: '51173'},
  {name: 'Southampton County', fips: '51175'},
  {name: 'Spotsylvania County', fips: '51177'},
  {name: 'Stafford County', fips: '51179'},
  {name: 'Surry County', fips: '51181'},
  {name: 'Sussex County', fips: '51183'},
  {name: 'Tazewell County', fips: '51185'},
  {name: 'Warren County', fips: '51187'},
  {name: 'Washington County', fips: '51191'},
  {name: 'Westmoreland County', fips: '51193'},
  {name: 'Wise County', fips: '51195'},
  {name: 'Wythe County', fips: '51197'},
  {name: 'York County', fips: '51199'},
  // Virginia Independent Cities
  {name: 'Alexandria city', fips: '51510'},
  {name: 'Bristol city', fips: '51520'},
  {name: 'Buena Vista city', fips: '51530'},
  {name: 'Charlottesville city', fips: '51540'},
  {name: 'Chesapeake city', fips: '51550'},
  {name: 'Colonial Heights city', fips: '51570'},
  {name: 'Covington city', fips: '51580'},
  {name: 'Danville city', fips: '51590'},
  {name: 'Emporia city', fips: '51595'},
  {name: 'Fairfax city', fips: '51600'},
  {name: 'Falls Church city', fips: '51610'},
  {name: 'Franklin city', fips: '51620'},
  {name: 'Fredericksburg city', fips: '51630'},
  {name: 'Galax city', fips: '51640'},
  {name: 'Hampton city', fips: '51650'},
  {name: 'Harrisonburg city', fips: '51660'},
  {name: 'Hopewell city', fips: '51670'},
  {name: 'Lexington city', fips: '51678'},
  {name: 'Lynchburg city', fips: '51680'},
  {name: 'Manassas city', fips: '51683'},
  {name: 'Manassas Park city', fips: '51685'},
  {name: 'Martinsville city', fips: '51690'},
  {name: 'Newport News city', fips: '51700'},
  {name: 'Norfolk city', fips: '51710'},
  {name: 'Norton city', fips: '51720'},
  {name: 'Petersburg city', fips: '51730'},
  {name: 'Poquoson city', fips: '51735'},
  {name: 'Portsmouth city', fips: '51740'},
  {name: 'Radford city', fips: '51750'},
  {name: 'Richmond city', fips: '51760'},
  {name: 'Roanoke city', fips: '51770'},
  {name: 'Salem city', fips: '51775'},
  {name: 'Staunton city', fips: '51790'},
  {name: 'Suffolk city', fips: '51800'},
  {name: 'Virginia Beach city', fips: '51810'},
  {name: 'Waynesboro city', fips: '51820'},
  {name: 'Williamsburg city', fips: '51830'},
  {name: 'Winchester city', fips: '51840'},

  // Washington (53)
  {name: 'Adams County', fips: '53001'},
  {name: 'Asotin County', fips: '53003'},
  {name: 'Benton County', fips: '53005'},
  {name: 'Chelan County', fips: '53007'},
  {name: 'Clallam County', fips: '53009'},
  {name: 'Clark County', fips: '53011'},
  {name: 'Columbia County', fips: '53013'},
  {name: 'Cowlitz County', fips: '53015'},
  {name: 'Douglas County', fips: '53017'},
  {name: 'Ferry County', fips: '53019'},
  {name: 'Franklin County', fips: '53021'},
  {name: 'Garfield County', fips: '53023'},
  {name: 'Grant County', fips: '53025'},
  {name: 'Grays Harbor County', fips: '53027'},
  {name: 'Island County', fips: '53029'},
  {name: 'Jefferson County', fips: '53031'},
  {name: 'King County', fips: '53033'},
  {name: 'Kitsap County', fips: '53035'},
  {name: 'Kittitas County', fips: '53037'},
  {name: 'Klickitat County', fips: '53039'},
  {name: 'Lewis County', fips: '53041'},
  {name: 'Lincoln County', fips: '53043'},
  {name: 'Mason County', fips: '53045'},
  {name: 'Okanogan County', fips: '53047'},
  {name: 'Pacific County', fips: '53049'},
  {name: 'Pend Oreille County', fips: '53051'},
  {name: 'Pierce County', fips: '53053'},
  {name: 'San Juan County', fips: '53055'},
  {name: 'Skagit County', fips: '53057'},
  {name: 'Skamania County', fips: '53059'},
  {name: 'Snohomish County', fips: '53061'},
  {name: 'Spokane County', fips: '53063'},
  {name: 'Stevens County', fips: '53065'},
  {name: 'Thurston County', fips: '53067'},
  {name: 'Wahkiakum County', fips: '53069'},
  {name: 'Walla Walla County', fips: '53071'},
  {name: 'Whatcom County', fips: '53073'},
  {name: 'Whitman County', fips: '53075'},
  {name: 'Yakima County', fips: '53077'},

  // West Virginia (54)
  {name: 'Barbour County', fips: '54001'},
  {name: 'Berkeley County', fips: '54003'},
  {name: 'Boone County', fips: '54005'},
  {name: 'Braxton County', fips: '54007'},
  {name: 'Brooke County', fips: '54009'},
  {name: 'Cabell County', fips: '54011'},
  {name: 'Calhoun County', fips: '54013'},
  {name: 'Clay County', fips: '54015'},
  {name: 'Doddridge County', fips: '54017'},
  {name: 'Fayette County', fips: '54019'},
  {name: 'Gilmer County', fips: '54021'},
  {name: 'Grant County', fips: '54023'},
  {name: 'Greenbrier County', fips: '54025'},
  {name: 'Hampshire County', fips: '54027'},
  {name: 'Hancock County', fips: '54029'},
  {name: 'Hardy County', fips: '54031'},
  {name: 'Harrison County', fips: '54033'},
  {name: 'Jackson County', fips: '54035'},
  {name: 'Jefferson County', fips: '54037'},
  {name: 'Kanawha County', fips: '54039'},
  {name: 'Lewis County', fips: '54041'},
  {name: 'Lincoln County', fips: '54043'},
  {name: 'Logan County', fips: '54045'},
  {name: 'McDowell County', fips: '54047'},
  {name: 'Marion County', fips: '54049'},
  {name: 'Marshall County', fips: '54051'},
  {name: 'Mason County', fips: '54053'},
  {name: 'Mercer County', fips: '54055'},
  {name: 'Mineral County', fips: '54057'},
  {name: 'Mingo County', fips: '54059'},
  {name: 'Monongalia County', fips: '54061'},
  {name: 'Monroe County', fips: '54063'},
  {name: 'Morgan County', fips: '54065'},
  {name: 'Nicholas County', fips: '54067'},
  {name: 'Ohio County', fips: '54069'},
  {name: 'Pendleton County', fips: '54071'},
  {name: 'Pleasants County', fips: '54073'},
  {name: 'Pocahontas County', fips: '54075'},
  {name: 'Preston County', fips: '54077'},
  {name: 'Putnam County', fips: '54079'},
  {name: 'Raleigh County', fips: '54081'},
  {name: 'Randolph County', fips: '54083'},
  {name: 'Ritchie County', fips: '54085'},
  {name: 'Roane County', fips: '54087'},
  {name: 'Summers County', fips: '54089'},
  {name: 'Taylor County', fips: '54091'},
  {name: 'Tucker County', fips: '54093'},
  {name: 'Tyler County', fips: '54095'},
  {name: 'Upshur County', fips: '54097'},
  {name: 'Wayne County', fips: '54099'},
  {name: 'Webster County', fips: '54101'},
  {name: 'Wetzel County', fips: '54103'},
  {name: 'Wirt County', fips: '54105'},
  {name: 'Wood County', fips: '54107'},
  {name: 'Wyoming County', fips: '54109'},

  // Wisconsin (55)
  {name: 'Adams County', fips: '55001'},
  {name: 'Ashland County', fips: '55003'},
  {name: 'Barron County', fips: '55005'},
  {name: 'Bayfield County', fips: '55007'},
  {name: 'Brown County', fips: '55009'},
  {name: 'Buffalo County', fips: '55011'},
  {name: 'Burnett County', fips: '55013'},
  {name: 'Calumet County', fips: '55015'},
  {name: 'Chippewa County', fips: '55017'},
  {name: 'Clark County', fips: '55019'},
  {name: 'Columbia County', fips: '55021'},
  {name: 'Crawford County', fips: '55023'},
  {name: 'Dane County', fips: '55025'},
  {name: 'Dodge County', fips: '55027'},
  {name: 'Door County', fips: '55029'},
  {name: 'Douglas County', fips: '55031'},
  {name: 'Dunn County', fips: '55033'},
  {name: 'Eau Claire County', fips: '55035'},
  {name: 'Florence County', fips: '55037'},
  {name: 'Fond du Lac County', fips: '55039'},
  {name: 'Forest County', fips: '55041'},
  {name: 'Grant County', fips: '55043'},
  {name: 'Green County', fips: '55045'},
  {name: 'Green Lake County', fips: '55047'},
  {name: 'Iowa County', fips: '55049'},
  {name: 'Iron County', fips: '55051'},
  {name: 'Jackson County', fips: '55053'},
  {name: 'Jefferson County', fips: '55055'},
  {name: 'Juneau County', fips: '55057'},
  {name: 'Kenosha County', fips: '55059'},
  {name: 'Kewaunee County', fips: '55061'},
  {name: 'La Crosse County', fips: '55063'},
  {name: 'Lafayette County', fips: '55065'},
  {name: 'Langlade County', fips: '55067'},
  {name: 'Lincoln County', fips: '55069'},
  {name: 'Manitowoc County', fips: '55071'},
  {name: 'Marathon County', fips: '55073'},
  {name: 'Marinette County', fips: '55075'},
  {name: 'Marquette County', fips: '55077'},
  {name: 'Menominee County', fips: '55078'},
  {name: 'Milwaukee County', fips: '55079'},
  {name: 'Monroe County', fips: '55081'},
  {name: 'Oconto County', fips: '55083'},
  {name: 'Oneida County', fips: '55085'},
  {name: 'Outagamie County', fips: '55087'},
  {name: 'Ozaukee County', fips: '55089'},
  {name: 'Pepin County', fips: '55091'},
  {name: 'Pierce County', fips: '55093'},
  {name: 'Polk County', fips: '55095'},
  {name: 'Portage County', fips: '55097'},
  {name: 'Price County', fips: '55099'},
  {name: 'Racine County', fips: '55101'},
  {name: 'Richland County', fips: '55103'},
  {name: 'Rock County', fips: '55105'},
  {name: 'Rusk County', fips: '55107'},
  {name: 'St. Croix County', fips: '55109'},
  {name: 'Sauk County', fips: '55111'},
  {name: 'Sawyer County', fips: '55113'},
  {name: 'Shawano County', fips: '55115'},
  {name: 'Sheboygan County', fips: '55117'},
  {name: 'Taylor County', fips: '55119'},
  {name: 'Trempealeau County', fips: '55121'},
  {name: 'Vernon County', fips: '55123'},
  {name: 'Vilas County', fips: '55125'},
  {name: 'Walworth County', fips: '55127'},
  {name: 'Washburn County', fips: '55129'},
  {name: 'Washington County', fips: '55131'},
  {name: 'Waukesha County', fips: '55133'},
  {name: 'Waupaca County', fips: '55135'},
  {name: 'Waushara County', fips: '55137'},
  {name: 'Winnebago County', fips: '55139'},
  {name: 'Wood County', fips: '55141'},

  // Wyoming (56)
  {name: 'Albany County', fips: '56001'},
  {name: 'Big Horn County', fips: '56003'},
  {name: 'Campbell County', fips: '56005'},
  {name: 'Carbon County', fips: '56007'},
  {name: 'Converse County', fips: '56009'},
  {name: 'Crook County', fips: '56011'},
  {name: 'Fremont County', fips: '56013'},
  {name: 'Goshen County', fips: '56015'},
  {name: 'Hot Springs County', fips: '56017'},
  {name: 'Johnson County', fips: '56019'},
  {name: 'Laramie County', fips: '56021'},
  {name: 'Lincoln County', fips: '56023'},
  {name: 'Natrona County', fips: '56025'},
  {name: 'Niobrara County', fips: '56027'},
  {name: 'Park County', fips: '56029'},
  {name: 'Platte County', fips: '56031'},
  {name: 'Sheridan County', fips: '56033'},
  {name: 'Sublette County', fips: '56035'},
  {name: 'Sweetwater County', fips: '56037'},
  {name: 'Teton County', fips: '56039'},
  {name: 'Uinta County', fips: '56041'},
  {name: 'Washakie County', fips: '56043'},
  {name: 'Weston County', fips: '56045'},

  // American Samoa (60)
  {name: 'Eastern District', fips: '60010'},
  {name: "Manu'a District", fips: '60020'},
  {name: 'Rose Atoll', fips: '60030'},
  {name: 'Swains Island', fips: '60040'},
  {name: 'Western District', fips: '60050'},

  // Guam (66)
  {name: 'Guam', fips: '66010'},

  // Northern Mariana Islands (69)
  {name: 'Northern Mariana Islands', fips: '69085'},
  {name: 'Rota Municipality', fips: '69100'},
  {name: 'Saipan Municipality', fips: '69110'},
  {name: 'Tinian Municipality', fips: '69120'},

  // Puerto Rico (72)
  {name: 'Adjuntas Municipio', fips: '72001'},
  {name: 'Aguada Municipio', fips: '72003'},
  {name: 'Aguadilla Municipio', fips: '72005'},
  {name: 'Aguas Buenas Municipio', fips: '72007'},
  {name: 'Aibonito Municipio', fips: '72009'},
  {name: 'Añasco Municipio', fips: '72011'},
  {name: 'Arecibo Municipio', fips: '72013'},
  {name: 'Arroyo Municipio', fips: '72015'},
  {name: 'Barceloneta Municipio', fips: '72017'},
  {name: 'Barranquitas Municipio', fips: '72019'},
  {name: 'Bayamón Municipio', fips: '72021'},
  {name: 'Cabo Rojo Municipio', fips: '72023'},
  {name: 'Caguas Municipio', fips: '72025'},
  {name: 'Camuy Municipio', fips: '72027'},
  {name: 'Canóvanas Municipio', fips: '72029'},
  {name: 'Carolina Municipio', fips: '72031'},
  {name: 'Cataño Municipio', fips: '72033'},
  {name: 'Cayey Municipio', fips: '72035'},
  {name: 'Ceiba Municipio', fips: '72037'},
  {name: 'Ciales Municipio', fips: '72039'},
  {name: 'Cidra Municipio', fips: '72041'},
  {name: 'Coamo Municipio', fips: '72043'},
  {name: 'Comerío Municipio', fips: '72045'},
  {name: 'Corozal Municipio', fips: '72047'},
  {name: 'Culebra Municipio', fips: '72049'},
  {name: 'Dorado Municipio', fips: '72051'},
  {name: 'Fajardo Municipio', fips: '72053'},
  {name: 'Florida Municipio', fips: '72054'},
  {name: 'Guánica Municipio', fips: '72055'},
  {name: 'Guayama Municipio', fips: '72057'},
  {name: 'Guayanilla Municipio', fips: '72059'},
  {name: 'Guaynabo Municipio', fips: '72061'},
  {name: 'Gurabo Municipio', fips: '72063'},
  {name: 'Hatillo Municipio', fips: '72065'},
  {name: 'Hormigueros Municipio', fips: '72067'},
  {name: 'Humacao Municipio', fips: '72069'},
  {name: 'Isabela Municipio', fips: '72071'},
  {name: 'Jayuya Municipio', fips: '72073'},
  {name: 'Juana Díaz Municipio', fips: '72075'},
  {name: 'Juncos Municipio', fips: '72077'},
  {name: 'Lajas Municipio', fips: '72079'},
  {name: 'Lares Municipio', fips: '72081'},
  {name: 'Las Marías Municipio', fips: '72083'},
  {name: 'Las Piedras Municipio', fips: '72085'},
  {name: 'Loíza Municipio', fips: '72087'},
  {name: 'Luquillo Municipio', fips: '72089'},
  {name: 'Manatí Municipio', fips: '72091'},
  {name: 'Maricao Municipio', fips: '72093'},
  {name: 'Maunabo Municipio', fips: '72095'},
  {name: 'Mayagüez Municipio', fips: '72097'},
  {name: 'Moca Municipio', fips: '72099'},
  {name: 'Morovis Municipio', fips: '72101'},
  {name: 'Naguabo Municipio', fips: '72103'},
  {name: 'Naranjito Municipio', fips: '72105'},
  {name: 'Orocovis Municipio', fips: '72107'},
  {name: 'Patillas Municipio', fips: '72109'},
  {name: 'Peñuelas Municipio', fips: '72111'},
  {name: 'Ponce Municipio', fips: '72113'},
  {name: 'Quebradillas Municipio', fips: '72115'},
  {name: 'Rincón Municipio', fips: '72117'},
  {name: 'Río Grande Municipio', fips: '72119'},
  {name: 'Sabana Grande Municipio', fips: '72121'},
  {name: 'Salinas Municipio', fips: '72123'},
  {name: 'San Germán Municipio', fips: '72125'},
  {name: 'San Juan Municipio', fips: '72127'},
  {name: 'San Lorenzo Municipio', fips: '72129'},
  {name: 'San Sebastián Municipio', fips: '72131'},
  {name: 'Santa Isabel Municipio', fips: '72133'},
  {name: 'Toa Alta Municipio', fips: '72135'},
  {name: 'Toa Baja Municipio', fips: '72137'},
  {name: 'Trujillo Alto Municipio', fips: '72139'},
  {name: 'Utuado Municipio', fips: '72141'},
  {name: 'Vega Alta Municipio', fips: '72143'},
  {name: 'Vega Baja Municipio', fips: '72145'},
  {name: 'Vieques Municipio', fips: '72147'},
  {name: 'Villalba Municipio', fips: '72149'},
  {name: 'Yabucoa Municipio', fips: '72151'},
  {name: 'Yauco Municipio', fips: '72153'},

  // U.S. Virgin Islands (78)
  {name: 'St. Croix', fips: '78010'},
  {name: 'St. John', fips: '78020'},
  {name: 'St. Thomas', fips: '78030'}
]

export const countyFipsMap = new Map(counties.map((c) => [c.fips, c.name]))
